// @ts-nocheck
/**
 * Rebuy Smart Cart enhancements:
 * 1) Free-shipping banner (below header, styled in app-overrides.css).
 * 2) Structured bundle component rows under Stay AI bundle parent lines (bundle_parent:true).
 * 3) Cross-sell widget moved into the cart footer (above subtotal).
 */
(function () {
  "use strict";

  var CART_ITEMS_SEL = '[data-rebuy-component="cart-items"]';
  var INJECTED_CLASS = "rebuy-cart__stay-bundle-contents";
  var BANNER_ID = "lsg-rebuy-free-shipping-banner";
  var PARENT_CHIP_MARKER = "rebuy-cart__stay-bundle-parent-chip";
  var BUNDLE_BOXES_LABEL_CLASS = "rebuy-cart__stay-bundle-boxes-label";
  var CROSS_SELL_FOOTER_CLASS = "lsg-rebuy-cross-sell--in-footer";
  var debounceTimer = null;
  var dedupeSoonTimer = null;
  var dedupePassTimer = null;
  var dedupeMutTimer = null;
  var subscriptionDedupeObserverStarted = false;
  var bundleSubSyncingUi = false;
  var bundleSubCartUpdating = false;
  var bundleSubHydrateQueued = false;
  var bundleSubHydrateSkipRepair = false;
  var bundleSubSuppressScheduleUntil = 0;
  var bundleSubAwaitingHydrateReveal = false;
  /** @type {Record<string, { selectValue: string, subPercent: number }> | null} */
  var bundleSubHydratePricingIntentByBid = null;
  var bundleSubActiveBidNorm = "";
  /** @type {MutationObserver | null} */
  var bundleSubRowObserver = null;
  var bundleSubMarkerRaf = 0;
  var BUNDLE_SUB_ROW_HIDDEN_CLASS = "lsg-rebuy-bundle-sub-row-hidden";
  var BUNDLE_SUB_SKELETON_CLASS = "lsg-rebuy-cart-price-skeleton";
  var BUNDLE_SUB_SKELETON_HOST_CLASS = "lsg-rebuy-cart-price-skeleton-host";
  var BUNDLE_SUB_SKELETON_MAX_ROWS = 4;
  var bundleSubUiDelayTimer = null;
  var BUNDLE_SUB_UI_DELAY_MS = 300;
  var BUNDLE_SUB_SUBTOTAL_STABILITY_MS = 150;
  /** @type {MutationObserver | null} */
  var bundleSubSubtotalObserver = null;
  /** @type {Element | null} */
  var bundleSubSubtotalObservedEl = null;
  /** @type {Record<string, { selectValue: string, subPercent: number }> | null} */
  var bundleSubGuardPricingIntentByBid = null;
  var bundleSubSubtotalMutationTimer = null;
  var bundleSubStableReleaseTimer = null;
  var bundleSubSubtotalLastMutationAt = 0;
  var bundleSubGuardRepainting = false;
  var bundleSubRebuyListenersActive = false;
  var bundleSubReleasePhase = false;
  var bundleSubReleaseStartedAt = 0;
  var BUNDLE_SUB_MAX_RELEASE_MS = 3000;
  var bundleSubMaxReleaseTimer = null;
  /** @type {{ flyout: HTMLElement, cart: any, bidNorm: string, pricingIntent: { selectValue: string, subPercent: number } | null } | null} */
  var bundleSubStableReleasePending = null;
  /** @type {any} */
  var bundleSubLastCartForGuard = null;
  var REBUY_CART_SYNC_EVENTS = [
    "rebuy:smartcart.cart-updated",
    "rebuy:smartcart:cart-updated",
    "rebuy:cart.change",
    "rebuy:cart-updated",
  ];
  /** @type {any[]} */
  var lastCartItems = [];
  /** @type {Record<string, { selectValue: string, subPercent: number }>} */
  var pendingBundleSubscriptionByBid = {};
  /** @type {Record<string, Promise<{ default: string, byVariantId: Record<string, string> } | null>>} */
  var productThumbnailCache = {};
  /** @type {Record<string, Promise<any>>} */
  var productJsonCache = {};

  /** @returns {string} */
  function decodeHtmlString(value) {
    var decoded = String(value || "");
    var textarea = document.createElement("textarea");
    for (var i = 0; i < 2; i++) {
      textarea.innerHTML = decoded;
      if (textarea.value === decoded) break;
      decoded = textarea.value;
    }
    return decoded;
  }

  /** @returns {Record<string,string>} */
  function lsgStrings() {
    var c = window.LSG_REBUY_CART || {};
    var s = c.strings || {};
    return {
      heading: decodeHtmlString(s.freeShippingHeading || "Free Shipping"),
      remainingTpl: decodeHtmlString(
        s.freeShippingRemainingTpl ||
          "You are {{ remainder }} away from free shipping!",
      ),
      unlocked: decodeHtmlString(
        s.freeShippingUnlocked || "You've unlocked free shipping!",
      ),
      bundleBoxesTpl: decodeHtmlString(
        s.bundleBoxes || "Bundle {{ count }} Boxes",
      ),
    };
  }

  /** @param {string} tpl @param {string} count */
  function applyCountTemplate(tpl, count) {
    return String(tpl).replace(/\{\{\s*count\s*\}\}/g, count);
  }

  function shopifyRoot() {
    if (typeof Theme !== "undefined" && Theme.routes && Theme.routes.root) {
      var root = Theme.routes.root;
      if (root.slice(-1) !== "/") root += "/";
      return root;
    }
    var r =
      typeof Shopify !== "undefined" && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : "/";
    if (r.slice(-1) !== "/") r += "/";
    return r;
  }

  function cartJsUrl() {
    if (typeof Theme !== "undefined" && Theme.routes && Theme.routes.cart_url) {
      return Theme.routes.cart_url + ".js";
    }
    return shopifyRoot() + "cart.js";
  }

  function cartChangeUrl() {
    if (
      typeof Theme !== "undefined" &&
      Theme.routes &&
      Theme.routes.cart_change_url
    ) {
      return Theme.routes.cart_change_url;
    }
    return shopifyRoot() + "cart/change.js";
  }

  function cartUpdateUrl() {
    return shopifyRoot() + "cart/update.js";
  }

  function cartAddUrl() {
    return shopifyRoot() + "cart/add.js";
  }

  /** @param {any} cart */
  function cacheLastCartItems(cart) {
    if (cart && Array.isArray(cart.items)) {
      lastCartItems = cart.items;
    }
  }

  /** @returns {Promise<any | null>} */
  function fetchCartJson() {
    return fetch(cartJsUrl(), {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        cacheLastCartItems(cart);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  /** Lock cart-items height so Rebuy re-renders do not collapse the list. */
  /** @param {boolean} active */
  function setBundleSubPendingLayout(active) {
    var root = document.querySelector(CART_ITEMS_SEL);
    var flyout = document.querySelector(".rebuy-cart__flyout");
    if (!flyout) return;
    if (active) {
      if (root) {
        var h = root.offsetHeight;
        if (h > 0) root.style.minHeight = h + "px";
      }
      flyout.classList.add("lsg-rebuy-bundle-sub-pending");
      mountBundleSubCartSkeleton(flyout);
    } else {
      if (root) root.style.minHeight = "";
      flyout.classList.remove("lsg-rebuy-bundle-sub-pending");
      removeBundleSubCartSkeleton(flyout);
    }
  }

  /**
   * @param {number} count
   * @returns {string}
   */
  function bundleSubSkeletonRowsHtml(count) {
    var rows = Math.max(1, Math.min(count, BUNDLE_SUB_SKELETON_MAX_ROWS));
    var html = "";
    for (var i = 0; i < rows; i++) {
      html +=
        '<div class="lsg-rebuy-cart-price-skeleton__row">' +
        '<span class="lsg-rebuy-cart-price-skeleton__media"></span>' +
        '<span class="lsg-rebuy-cart-price-skeleton__lines">' +
        '<span class="lsg-rebuy-cart-price-skeleton__line lsg-rebuy-cart-price-skeleton__line--title"></span>' +
        '<span class="lsg-rebuy-cart-price-skeleton__line lsg-rebuy-cart-price-skeleton__line--meta"></span>' +
        '<span class="lsg-rebuy-cart-price-skeleton__line lsg-rebuy-cart-price-skeleton__line--price"></span>' +
        "</span></div>";
    }
    return html;
  }

  /**
   * @param {HTMLElement} host
   * @param {string} innerHtml
   */
  function attachBundleSubSkeletonToHost(host, innerHtml) {
    host.classList.add(BUNDLE_SUB_SKELETON_HOST_CLASS);
    var existing = host.querySelector("." + BUNDLE_SUB_SKELETON_CLASS);
    if (existing) existing.remove();
    var overlay = document.createElement("div");
    overlay.className = BUNDLE_SUB_SKELETON_CLASS;
    overlay.setAttribute("aria-hidden", "true");
    overlay.innerHTML =
      '<div class="lsg-rebuy-cart-price-skeleton__panel">' + innerHtml + "</div>";
    host.appendChild(overlay);
  }

  /**
   * @param {HTMLElement | null} flyout
   */
  function mountBundleSubCartSkeleton(flyout) {
    if (!flyout) return;
    var cartItems = flyout.querySelector(CART_ITEMS_SEL);
    if (cartItems) {
      var rowCount = cartItems.querySelectorAll(".rebuy-cart__flyout-item").length;
      attachBundleSubSkeletonToHost(
        /** @type {HTMLElement} */ (cartItems),
        bundleSubSkeletonRowsHtml(rowCount || 2),
      );
    }
    var subtotal = flyout.querySelector('[data-rebuy-component="cart-subtotal"]');
    if (subtotal) {
      attachBundleSubSkeletonToHost(
        /** @type {HTMLElement} */ (subtotal),
        '<div class="lsg-rebuy-cart-price-skeleton__subtotal">' +
          '<span class="lsg-rebuy-cart-price-skeleton__line lsg-rebuy-cart-price-skeleton__line--label"></span>' +
          '<span class="lsg-rebuy-cart-price-skeleton__line lsg-rebuy-cart-price-skeleton__line--amount"></span>' +
          "</div>",
      );
    }
  }

  /**
   * @param {HTMLElement | null} flyout
   */
  function ensureBundleSubCartSkeleton(flyout) {
    if (!flyout || !bundleSubCartUpdating || bundleSubReleasePhase) return;
    var cartItems = flyout.querySelector(CART_ITEMS_SEL);
    if (cartItems && !cartItems.querySelector("." + BUNDLE_SUB_SKELETON_CLASS)) {
      var rowCount = cartItems.querySelectorAll(".rebuy-cart__flyout-item").length;
      attachBundleSubSkeletonToHost(
        /** @type {HTMLElement} */ (cartItems),
        bundleSubSkeletonRowsHtml(rowCount || 2),
      );
    }
    var subtotal = flyout.querySelector('[data-rebuy-component="cart-subtotal"]');
    if (subtotal && !subtotal.querySelector("." + BUNDLE_SUB_SKELETON_CLASS)) {
      attachBundleSubSkeletonToHost(
        /** @type {HTMLElement} */ (subtotal),
        '<div class="lsg-rebuy-cart-price-skeleton__subtotal">' +
          '<span class="lsg-rebuy-cart-price-skeleton__line lsg-rebuy-cart-price-skeleton__line--label"></span>' +
          '<span class="lsg-rebuy-cart-price-skeleton__line lsg-rebuy-cart-price-skeleton__line--amount"></span>' +
          "</div>",
      );
    }
  }

  /**
   * @param {HTMLElement | null} flyout
   */
  function removeBundleSubCartSkeleton(flyout) {
    if (!flyout) return;
    flyout
      .querySelectorAll("." + BUNDLE_SUB_SKELETON_HOST_CLASS)
      .forEach(function (host) {
        host.classList.remove(BUNDLE_SUB_SKELETON_HOST_CLASS);
        host.querySelectorAll("." + BUNDLE_SUB_SKELETON_CLASS).forEach(function (el) {
          el.remove();
        });
      });
  }

  /** @param {HTMLElement | null} [flyout] */
  function resetBundleSubCartItemsLayout(flyout) {
    var scope = flyout || document.querySelector(".rebuy-cart__flyout");
    if (!scope) return;

    scope.querySelectorAll(CART_ITEMS_SEL).forEach(function (root) {
      /** @type {HTMLElement} */ (root).style.minHeight = "";
    });

    if (!bundleSubCartUpdating) {
      scope.classList.remove("lsg-rebuy-bundle-sub-pending");
      scope.classList.remove("lsg-rebuy-bundle-sub-updating");
    }
  }

  /** @param {HTMLElement} flyout */
  function isRebuyFlyoutOpen(flyout) {
    return (
      flyout.classList.contains("active") ||
      flyout.classList.contains("is-active") ||
      flyout.getAttribute("aria-hidden") === "false"
    );
  }

  var bundleSubFlyoutLayoutObserver = null;
  var bundleSubFlyoutLayoutObservedEl = null;

  function syncBundleSubFlyoutLayoutRecovery() {
    var flyout = document.querySelector(".rebuy-cart__flyout");
    if (!flyout) return;
    if (isRebuyFlyoutOpen(flyout)) {
      resetBundleSubCartItemsLayout(flyout);
    }
  }

  function startBundleSubFlyoutLayoutRecoveryObserver() {
    var flyout = document.querySelector(".rebuy-cart__flyout");
    if (!flyout) return;

    if (bundleSubFlyoutLayoutObservedEl !== flyout) {
      if (bundleSubFlyoutLayoutObserver) {
        bundleSubFlyoutLayoutObserver.disconnect();
        bundleSubFlyoutLayoutObserver = null;
      }
      bundleSubFlyoutLayoutObservedEl = flyout;
      bundleSubFlyoutLayoutObserver = new MutationObserver(function () {
        syncBundleSubFlyoutLayoutRecovery();
      });
      bundleSubFlyoutLayoutObserver.observe(flyout, {
        attributes: true,
        attributeFilter: ["class", "aria-hidden"],
        childList: true,
        subtree: false,
      });
    }

    syncBundleSubFlyoutLayoutRecovery();
  }

  /** @type {MutationObserver | null} */
  var freeShipBannerObserver = null;
  /** @type {Element | null} */
  var freeShipBannerObservedFlyout = null;
  /** @type {ReturnType<typeof setTimeout> | null} */
  var freeShipBannerRefreshTimer = null;

  /**
   * Keep the themed free-shipping banner mounted + in sync. Rebuy re-renders the
   * header/goalBox region (e.g. when its native progress bar updates) and wipes
   * our injected banner; this observer re-injects and mirrors the native bar
   * whenever that region changes, independent of cart:update events.
   */
  function startFreeShippingBannerObserver() {
    var flyout = document.querySelector(".rebuy-cart__flyout");
    if (!flyout) return;
    if (freeShipBannerObservedFlyout === flyout && freeShipBannerObserver) {
      updateFreeShippingBanner(/** @type {HTMLElement} */ (flyout));
      return;
    }
    if (freeShipBannerObserver) freeShipBannerObserver.disconnect();
    freeShipBannerObservedFlyout = flyout;

    freeShipBannerObserver = new MutationObserver(function (mutations) {
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (!(t instanceof Element)) continue;
        if (
          t === flyout ||
          t.closest('[data-rebuy-cart-anchor="goalBox"]') ||
          t.closest('[data-rebuy-cart-anchor="header"]') ||
          t.id === BANNER_ID ||
          t.closest("#" + BANNER_ID)
        ) {
          relevant = true;
          break;
        }
      }
      if (!relevant) return;
      if (freeShipBannerRefreshTimer) clearTimeout(freeShipBannerRefreshTimer);
      freeShipBannerRefreshTimer = setTimeout(function () {
        updateFreeShippingBanner(/** @type {HTMLElement} */ (flyout));
      }, 60);
    });
    freeShipBannerObserver.observe(flyout, { childList: true, subtree: true });
    updateFreeShippingBanner(/** @type {HTMLElement} */ (flyout));
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        startBundleSubFlyoutLayoutRecoveryObserver();
        startFreeShippingBannerObserver();
      },
      { once: true },
    );
  } else {
    startBundleSubFlyoutLayoutRecoveryObserver();
    startFreeShippingBannerObserver();
  }

  new MutationObserver(function () {
    if (document.querySelector(".rebuy-cart__flyout")) {
      startBundleSubFlyoutLayoutRecoveryObserver();
      startFreeShippingBannerObserver();
    }
  }).observe(document.body, { childList: true, subtree: true });

  function clearBundleSubUiTimers() {
    if (bundleSubUiDelayTimer) {
      clearTimeout(bundleSubUiDelayTimer);
      bundleSubUiDelayTimer = null;
    }
  }

  /** @param {boolean} active */
  function scheduleBundleSubUpdatingUiFallback(active) {
    clearBundleSubUiTimers();
    if (!active) return;
    bundleSubUiDelayTimer = setTimeout(function () {
      if (bundleSubCartUpdating) setBundleSubUpdatingUi(true);
    }, BUNDLE_SUB_UI_DELAY_MS);
  }

  /**
   * @param {HTMLElement | null} flyout
   * @param {string} bidNorm
   */
  function markBundleSubRowsForBid(flyout, bidNorm) {
    if (!flyout || !bidNorm) return;
    flyout.querySelectorAll(".rebuy-cart__flyout-item").forEach(function (row) {
      var rowBid = normBid(getFlyoutProp(/** @type {HTMLElement} */ (row), "bundle_id"));
      /** @type {HTMLElement} */ (row).classList.toggle(
        BUNDLE_SUB_ROW_HIDDEN_CLASS,
        rowBid === bidNorm,
      );
    });
  }

  /** @param {HTMLElement | null} [flyout] */
  function clearBundleSubRowMarkers(flyout) {
    var scope =
      flyout || document.querySelector(".rebuy-cart__flyout");
    if (!scope) return;
    scope.querySelectorAll("." + BUNDLE_SUB_ROW_HIDDEN_CLASS).forEach(function (row) {
      /** @type {HTMLElement} */ (row).classList.remove(BUNDLE_SUB_ROW_HIDDEN_CLASS);
    });
    bundleSubActiveBidNorm = "";
  }

  function reapplyBundleSubRowMarkersNow() {
    if (!bundleSubCartUpdating || !bundleSubActiveBidNorm) return;
    var flyout = document.querySelector(".rebuy-cart__flyout");
    if (!flyout) return;
    flyout.classList.add("lsg-rebuy-bundle-sub-updating");
    flyout.classList.add("lsg-rebuy-bundle-sub-pending");
    markBundleSubRowsForBid(flyout, bundleSubActiveBidNorm);
    ensureBundleSubCartSkeleton(flyout);
  }

  function reapplyBundleSubRowMarkers() {
    if (!bundleSubCartUpdating || !bundleSubActiveBidNorm) return;
    if (bundleSubMarkerRaf) return;
    bundleSubMarkerRaf = requestAnimationFrame(function () {
      bundleSubMarkerRaf = 0;
      reapplyBundleSubRowMarkersNow();
    });
  }

  function startBundleSubRowObserver() {
    if (bundleSubRowObserver) return;
    var flyout = document.querySelector(".rebuy-cart__flyout");
    if (!flyout) return;
    bundleSubRowObserver = new MutationObserver(function () {
      reapplyBundleSubRowMarkers();
    });
    bundleSubRowObserver.observe(flyout, { childList: true, subtree: true });
  }

  function stopBundleSubRowObserver() {
    if (!bundleSubRowObserver) return;
    bundleSubRowObserver.disconnect();
    bundleSubRowObserver = null;
  }

  /**
   * @param {string} bidNorm
   * @returns {Record<string, { selectValue: string, subPercent: number }> | null}
   */
  function pricingIntentByBidForActiveBid(bidNorm) {
    if (!bidNorm) return null;
    var pending = getPendingBundleSubscription(bidNorm);
    if (!pending) return null;
    /** @type {Record<string, { selectValue: string, subPercent: number }>} */
    var map = {};
    map[bidNorm] = pending;
    return map;
  }

  function reapplyBundleSubGuardPricing() {
    if (
      bundleSubReleasePhase ||
      !bundleSubCartUpdating ||
      !bundleSubGuardPricingIntentByBid
    ) {
      return;
    }
    var flyout = document.querySelector(".rebuy-cart__flyout");
    if (!flyout) return;
    var cartItems = lastCartItems;
    if (
      !cartItems.length &&
      bundleSubLastCartForGuard &&
      bundleSubLastCartForGuard.items
    ) {
      cartItems = bundleSubLastCartForGuard.items;
    }
    bundleSubGuardRepainting = true;
    try {
      applyBundleCartPricing(
        flyout,
        { items: cartItems },
        bundleSubGuardPricingIntentByBid,
      );
    } finally {
      bundleSubGuardRepainting = false;
    }
    ensureBundleSubtotalObserver(flyout);
    ensureBundleSubCartSkeleton(flyout);
  }

  function onBundleSubSubtotalMutated() {
    if (bundleSubGuardRepainting) return;
    bundleSubSubtotalLastMutationAt = Date.now();
    if (bundleSubSubtotalMutationTimer) {
      clearTimeout(bundleSubSubtotalMutationTimer);
    }
    bundleSubSubtotalMutationTimer = setTimeout(function () {
      bundleSubSubtotalMutationTimer = null;
      reapplyBundleSubGuardPricing();
    }, 0);
    if (!bundleSubReleasePhase) {
      scheduleBundleSubStableReleaseAttempt();
    }
  }

  function stopBundleSubtotalObserverOnly() {
    if (bundleSubSubtotalObserver) {
      bundleSubSubtotalObserver.disconnect();
      bundleSubSubtotalObserver = null;
    }
    bundleSubSubtotalObservedEl = null;
  }

  /**
   * @param {HTMLElement} flyout
   */
  function ensureBundleSubtotalObserver(flyout) {
    if (!bundleSubCartUpdating || !bundleSubGuardPricingIntentByBid) return;
    var subtotal = flyout.querySelector('[data-rebuy-component="cart-subtotal"]');
    if (!subtotal) return;
    if (bundleSubSubtotalObservedEl === subtotal && bundleSubSubtotalObserver) {
      return;
    }
    stopBundleSubtotalObserverOnly();
    bundleSubSubtotalObservedEl = subtotal;
    bundleSubSubtotalObserver = new MutationObserver(function () {
      onBundleSubSubtotalMutated();
    });
    bundleSubSubtotalObserver.observe(subtotal, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  /**
   * @param {HTMLElement} flyout
   * @param {Record<string, { selectValue: string, subPercent: number }> | null} pricingIntentByBid
   */
  function startBundleSubtotalGuard(flyout, pricingIntentByBid) {
    bundleSubGuardPricingIntentByBid = pricingIntentByBid;
    ensureBundleSubtotalObserver(flyout);
  }

  function stopBundleSubtotalGuard() {
    stopBundleSubtotalObserverOnly();
    bundleSubGuardPricingIntentByBid = null;
    if (bundleSubSubtotalMutationTimer) {
      clearTimeout(bundleSubSubtotalMutationTimer);
      bundleSubSubtotalMutationTimer = null;
    }
  }

  function onBundleSubRebuyCartEvent() {
    if (!bundleSubCartUpdating) return;
    reapplyBundleSubGuardPricing();
  }

  function startBundleSubRebuyListeners() {
    if (bundleSubRebuyListenersActive) return;
    bundleSubRebuyListenersActive = true;
    REBUY_CART_SYNC_EVENTS.forEach(function (name) {
      document.addEventListener(name, onBundleSubRebuyCartEvent);
    });
  }

  function stopBundleSubRebuyListeners() {
    if (!bundleSubRebuyListenersActive) return;
    bundleSubRebuyListenersActive = false;
    REBUY_CART_SYNC_EVENTS.forEach(function (name) {
      document.removeEventListener(name, onBundleSubRebuyCartEvent);
    });
  }

  function stopBundleSubStableRelease() {
    if (bundleSubStableReleaseTimer) {
      clearTimeout(bundleSubStableReleaseTimer);
      bundleSubStableReleaseTimer = null;
    }
    bundleSubStableReleasePending = null;
  }

  function clearBundleSubMaxReleaseTimer() {
    if (bundleSubMaxReleaseTimer) {
      clearTimeout(bundleSubMaxReleaseTimer);
      bundleSubMaxReleaseTimer = null;
    }
  }

  /**
   * @param {HTMLElement | null} flyout
   */
  function restoreBundleSubPriceVisibility(flyout) {
    if (!flyout) return;
    flyout.querySelectorAll(".rebuy-cart__flyout-item").forEach(function (row) {
      /** @type {HTMLElement} */ (row).classList.remove(
        "lsg-rebuy-bundle-price-secondary",
      );
      var priceEl = row.querySelector(".rebuy-cart__flyout-item-price");
      if (priceEl) /** @type {HTMLElement} */ (priceEl).style.display = "";
    });
  }

  /**
   * @param {HTMLElement} flyout
   * @param {any} cart
   * @param {string} bidNorm
   * @param {{ selectValue: string, subPercent: number } | null} pricingIntent
   */
  function forceBundleSubReveal(flyout, cart, bidNorm, pricingIntent) {
    if (!flyout) {
      bundleSubReleasePhase = false;
      clearBundleSubMaxReleaseTimer();
      stopBundleSubStableRelease();
      bundleSubCartUpdating = false;
      return;
    }

    /** @type {Record<string, { selectValue: string, subPercent: number }> | null} */
    var pricingIntentByBid = null;
    if (bidNorm && pricingIntent) {
      pricingIntentByBid = {};
      pricingIntentByBid[bidNorm] = pricingIntent;
    }

    stopBundleSubStableRelease();
    clearBundleSubMaxReleaseTimer();
    applyBundleCartPricing(flyout, cart, pricingIntentByBid);
    bundleSubReleasePhase = false;
    releaseBundleSubMutationUi();
    bundleSubCartUpdating = false;
    restoreBundleSubPriceVisibility(flyout);
  }

  function tryBundleSubStableRelease() {
    if (!bundleSubStableReleasePending) return;
    var pending = bundleSubStableReleasePending;
    var stableMs = Date.now() - bundleSubSubtotalLastMutationAt;
    var forceExpired =
      Date.now() - bundleSubReleaseStartedAt >= BUNDLE_SUB_MAX_RELEASE_MS;

    void fetchCartJson().then(function (freshCart) {
      if (!bundleSubStableReleasePending) return;
      var cart = freshCart || pending.cart;
      var cartItems = cart.items || [];
      var cartMatches =
        !pending.bidNorm ||
        !pending.pricingIntent ||
        cartMatchesPendingSubscription(
          pending.bidNorm,
          cartItems,
          pending.pricingIntent,
        );

      if (
        forceExpired ||
        (cartMatches && stableMs >= BUNDLE_SUB_SUBTOTAL_STABILITY_MS)
      ) {
        forceBundleSubReveal(
          pending.flyout,
          cart,
          pending.bidNorm,
          pending.pricingIntent,
        );
        return;
      }
      scheduleBundleSubStableReleaseAttempt();
    });
  }

  function scheduleBundleSubStableReleaseAttempt() {
    if (!bundleSubStableReleasePending) return;
    if (bundleSubStableReleaseTimer) {
      clearTimeout(bundleSubStableReleaseTimer);
    }
    bundleSubStableReleaseTimer = setTimeout(function () {
      bundleSubStableReleaseTimer = null;
      tryBundleSubStableRelease();
    }, BUNDLE_SUB_SUBTOTAL_STABILITY_MS);
  }

  function scheduleBundleSubMaxReleaseFallback() {
    clearBundleSubMaxReleaseTimer();
    bundleSubMaxReleaseTimer = setTimeout(function () {
      bundleSubMaxReleaseTimer = null;
      if (!bundleSubStableReleasePending) return;
      var pending = bundleSubStableReleasePending;
      forceBundleSubReveal(
        pending.flyout,
        pending.cart,
        pending.bidNorm,
        pending.pricingIntent,
      );
    }, BUNDLE_SUB_MAX_RELEASE_MS);
  }

  /**
   * @param {HTMLElement} flyout
   * @param {any} cart
   * @param {string} bidNorm
   * @param {{ selectValue: string, subPercent: number } | null} pricingIntent
   */
  function scheduleBundleSubStableRelease(flyout, cart, bidNorm, pricingIntent) {
    bundleSubReleasePhase = true;
    bundleSubReleaseStartedAt = Date.now();
    stopBundleSubtotalGuard();
    stopBundleSubRebuyListeners();
    bundleSubStableReleasePending = {
      flyout: flyout,
      cart: cart,
      bidNorm: bidNorm,
      pricingIntent: pricingIntent,
    };
    bundleSubSubtotalLastMutationAt = Date.now();
    bundleSubSuppressScheduleUntil = Date.now() + 2000;
    scheduleBundleSubStableReleaseAttempt();
    scheduleBundleSubMaxReleaseFallback();
  }

  /**
   * @param {HTMLElement | null} flyout
   * @param {string} bidNorm
   * @param {Record<string, { selectValue: string, subPercent: number }> | null} [pricingIntentByBid]
   */
  function beginBundleSubMutationUi(flyout, bidNorm, pricingIntentByBid) {
    bundleSubActiveBidNorm = bidNorm || "";
    setBundleSubUpdatingUi(true);
    setBundleSubPendingLayout(true);
    if (flyout && bundleSubActiveBidNorm) {
      markBundleSubRowsForBid(flyout, bundleSubActiveBidNorm);
      startBundleSubRowObserver();
    }
    var intent = pricingIntentByBid || pricingIntentByBidForActiveBid(bidNorm);
    if (flyout && intent) {
      startBundleSubtotalGuard(flyout, intent);
      startBundleSubRebuyListeners();
    }
  }

  function releaseBundleSubMutationUi() {
    bundleSubReleasePhase = false;
    clearBundleSubMaxReleaseTimer();
    stopBundleSubStableRelease();
    stopBundleSubtotalGuard();
    stopBundleSubRebuyListeners();
    clearBundleSubUiTimers();
    stopBundleSubRowObserver();
    var flyout = document.querySelector(".rebuy-cart__flyout");
    clearBundleSubRowMarkers(flyout);
    setBundleSubUpdatingUi(false);
    setBundleSubPendingLayout(false);
    resetBundleSubCartItemsLayout(flyout);
    bundleSubLastCartForGuard = null;
  }

  /** @param {string} selectValue */
  function isSelectValueOnetime(selectValue) {
    var v = String(selectValue || "")
      .toLowerCase()
      .trim();
    return !v || v === "onetime";
  }

  /**
   * @param {string} bidNorm
   * @param {string} selectValue
   * @param {number} subPercent
   */
  function setPendingBundleSubscription(bidNorm, selectValue, subPercent) {
    if (!bidNorm) return;
    pendingBundleSubscriptionByBid[bidNorm] = {
      selectValue: String(selectValue || ""),
      subPercent: Number(subPercent) || 0,
    };
  }

  /** @param {string} bidNorm */
  function getPendingBundleSubscription(bidNorm) {
    return pendingBundleSubscriptionByBid[bidNorm] || null;
  }

  /** @param {string} bidNorm */
  function clearPendingBundleSubscription(bidNorm) {
    if (!bidNorm) return;
    delete pendingBundleSubscriptionByBid[bidNorm];
  }

  /** Hide line + subtotal prices while bundle subscription cart updates run. */
  /** @param {boolean} active */
  function setBundleSubUpdatingUi(active) {
    var flyout = document.querySelector(".rebuy-cart__flyout");
    if (!flyout) return;
    flyout.classList.toggle("lsg-rebuy-bundle-sub-updating", active);
  }

  /**
   * @param {string} bidNorm
   * @param {any[]} cartItems
   * @param {{ selectValue: string, subPercent: number }} pending
   */
  function cartMatchesPendingSubscription(bidNorm, cartItems, pending) {
    if (!pending) return true;

    var bundle = bundleCartLines(bidNorm, cartItems);
    /** @type {any[]} */
    var flavorItems = [];
    for (var i = 0; i < bundle.items.length; i++) {
      if (isBundleFlavorCartItem(bundle.items[i])) {
        flavorItems.push(bundle.items[i]);
      }
    }
    var checkItems = flavorItems.length ? flavorItems : bundle.items;
    if (!checkItems.length) return false;

    if (isSelectValueOnetime(pending.selectValue)) {
      for (var j = 0; j < checkItems.length; j++) {
        if (checkItems[j].selling_plan_allocation) return false;
      }
      return true;
    }

    if (!isBundleFullySubscription(checkItems)) return false;

    var needle = String(pending.selectValue).toLowerCase();
    for (var k = 0; k < checkItems.length; k++) {
      var plan = (checkItems[k].selling_plan_allocation || {}).selling_plan || {};
      var name = String(plan.name || "").toLowerCase();
      if (
        name !== needle &&
        name.indexOf(needle) === -1 &&
        needle.indexOf(name) === -1
      ) {
        return false;
      }
    }
    return true;
  }

  /**
   * @param {HTMLElement} flyout
   * @param {string} bidNorm
   * @returns {{ selectValue: string, subPercent: number } | null}
   */
  function bundleUiStateFromFlyout(flyout, bidNorm) {
    var flavorRows = getBundleFlavorRows(flyout, bidNorm);
    if (!flavorRows.length) return null;

    /** @type {string[]} */
    var values = [];
    /** @type {HTMLSelectElement | null} */
    var firstSelect = null;

    for (var i = 0; i < flavorRows.length; i++) {
      var sel = flavorRows[i].querySelector(
        ".rebuy-cart__flyout-item-subscription select",
      );
      if (!sel) return null;
      values.push(/** @type {HTMLSelectElement} */ (sel).value);
      if (!firstSelect) firstSelect = /** @type {HTMLSelectElement} */ (sel);
    }

    var first = values[0];
    for (var v = 1; v < values.length; v++) {
      if (values[v] !== first) return null;
    }

    return {
      selectValue: first,
      subPercent: firstSelect
        ? subscriptionDiscountPercentFromSelect(firstSelect)
        : 0,
    };
  }

  /**
   * @param {HTMLElement} flyout
   * @param {string} bidNorm
   * @returns {{ selectValue: string, subPercent: number } | null}
   */
  function resolveBundleUiStateForPricing(flyout, bidNorm) {
    var pending = getPendingBundleSubscription(bidNorm);
    if (pending) return pending;
    return bundleUiStateFromFlyout(flyout, bidNorm);
  }

  /** @param {string} handle */
  function productJsUrl(handle) {
    return shopifyRoot() + "products/" + encodeURIComponent(handle) + ".js";
  }

  /** @param {string} handle */
  function fetchProductJson(handle) {
    var key = String(handle || "").trim();
    if (!key) return Promise.resolve(null);
    if (productJsonCache[key]) return productJsonCache[key];
    productJsonCache[key] = fetch(productJsUrl(key), {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return null;
      });
    return productJsonCache[key];
  }

  /**
   * @param {string} handle
   * @param {string} selectValue
   * @returns {Promise<number | null>}
   */
  function resolveSellingPlanIdForSelectValue(handle, selectValue) {
    var val = String(selectValue || "").trim();
    if (!val || val.toLowerCase() === "onetime") return Promise.resolve(null);

    var numeric = parseInt(val, 10);
    if (!isNaN(numeric) && String(numeric) === val.replace(/\s/g, "")) {
      return Promise.resolve(numeric);
    }

    var needle = val.toLowerCase();
    return fetchProductJson(handle).then(function (product) {
      if (!product || !product.selling_plan_groups) return null;
      for (var g = 0; g < product.selling_plan_groups.length; g++) {
        var group = product.selling_plan_groups[g];
        var plans = group.selling_plans || [];
        for (var p = 0; p < plans.length; p++) {
          var plan = plans[p];
          var name = String(plan.name || "").toLowerCase();
          if (
            name === needle ||
            name.indexOf(needle) !== -1 ||
            needle.indexOf(name) !== -1
          ) {
            return plan.id;
          }
        }
      }
      return null;
    });
  }

  /** @param {any} cart */
  function dispatchCartUpdatedEvents(cart) {
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", { bubbles: true }),
      );
    } catch (e) {}
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent("shopify:cart:change", { bubbles: true }),
      );
    } catch (e2) {}
    if (cart && cart.items) {
      try {
        document.dispatchEvent(
          new CustomEvent("cart:update", {
            bubbles: true,
            detail: { resource: cart, sourceId: "rebuy-bundle-sub" },
          }),
        );
      } catch (e3) {}
    }
  }

  /**
   * Fallback free-shipping threshold (cents), used only when Rebuy's native
   * progress bar isn't present to mirror. The live value is normally read
   * straight from that bar (see `readRebuyNativeProgress`), which reflects the
   * Rebuy SmartCart "Tiered Progress Bar" unlock price.
   * @returns {number}
   */
  function freeShippingThresholdCents() {
    var c = window.LSG_REBUY_CART || {};
    var t = c.freeShippingThresholdCents;
    if (typeof t === "number" && t > 0) return t;
    return 4900;
  }

  /** @returns {string} */
  function activeCurrencyCode() {
    var code =
      typeof Shopify !== "undefined" &&
      Shopify.currency &&
      Shopify.currency.active &&
      Shopify.currency.active;
    return code || "USD";
  }

  /** @param {number} cents */
  function formatMoneyCents(cents) {
    return (Number(cents) / 100).toLocaleString(undefined, {
      style: "currency",
      currency: activeCurrencyCode(),
      minimumFractionDigits: 2,
    });
  }

  /** Strip hyphens + lowercase so UUIDs with/without dashes match. */
  function normBid(v) {
    return v == null ? "" : String(v).replace(/-/g, "").toLowerCase().trim();
  }

  /** @param {string} tpl */
  function applyRemainderTemplate(tpl, remainderFormatted) {
    return String(tpl).replace(/\{\{\s*remainder\s*\}\}/g, remainderFormatted);
  }

  /** @param {Element} li */
  function getFlyoutProp(li, keyLower) {
    var nameEls = li.querySelectorAll(".rebuy-cart__flyout-item-property-name");
    for (var i = 0; i < nameEls.length; i++) {
      var k = (nameEls[i].textContent || "")
        .trim()
        .replace(/\s*:\s*$/, "")
        .toLowerCase();
      if (k !== keyLower) continue;
      var prop = nameEls[i].closest(".rebuy-cart__flyout-item-property");
      var valEl =
        prop && prop.querySelector(".rebuy-cart__flyout-item-property-value");
      return valEl ? (valEl.textContent || "").trim() : "";
    }
    return "";
  }

  function isBundleParentRow(li) {
    var parent = getFlyoutProp(li, "bundle_parent").toLowerCase();
    if (parent !== "true") return false;
    return normBid(getFlyoutProp(li, "bundle_id")) !== "";
  }

  /** Bundle flavor/component line (has bundle_id, not bundle_parent). */
  function isBundleFlavorRow(row) {
    if (isBundleParentRow(row)) return false;
    return normBid(getFlyoutProp(row, "bundle_id")) !== "";
  }

  /** @param {number} qty */
  function formatBundleLineQty(qty) {
    var n = Number(qty) || 0;
    if (n > 1) return "\u00d7 " + n;
    if (n === 1) return "\u00d7 1";
    return "";
  }

  /** @param {HTMLElement} row */
  function parseQtyFromQuantityWidget(row) {
    var label = row.querySelector(
      ".rebuy-cart__flyout-item-quantity-widget-label",
    );
    if (!label) return 0;
    var match = (label.textContent || "").match(/(\d+)/);
    return match ? Number(match[1]) || 0 : 0;
  }

  /**
   * @param {HTMLElement} row
   * @param {any[]} cartItems
   * @param {Record<number, boolean>} usedCartItemIndexes
   * @returns {any | null}
   */
  function findCartItemForFlyoutRow(row, cartItems, usedCartItemIndexes) {
    var titleLink = row.querySelector(
      ".rebuy-cart__flyout-item-product-title",
    );
    var href = titleLink ? titleLink.getAttribute("href") || "" : "";
    var handleMatch = href.match(/\/products\/([^?#/]+)/);
    var handle = handleMatch ? handleMatch[1] : "";
    var variantTitleEl = row.querySelector(
      ".rebuy-cart__flyout-item-variant-title",
    );
    var variantTitle = normalizeVariantTitle(
      variantTitleEl ? variantTitleEl.textContent : "",
    );
    var bidNorm = normBid(getFlyoutProp(row, "bundle_id"));

    for (var i = 0; i < cartItems.length; i++) {
      if (usedCartItemIndexes[i]) continue;

      var ci = cartItems[i];
      var p = ci.properties;
      if (bidNorm) {
        if (!p || typeof p !== "object" || normBid(p.bundle_id) !== bidNorm) {
          continue;
        }
        var isParent = p.bundle_parent === true || p.bundle_parent === "true";
        if (isParent) continue;
      }

      if (
        ci.handle === handle &&
        normalizeVariantTitle(ci.variant_title) === variantTitle
      ) {
        usedCartItemIndexes[i] = true;
        return ci;
      }
    }

    return null;
  }

  /**
   * @param {HTMLElement} row
   * @param {any | null} cartItem
   */
  function replaceBundleLineQuantity(row, cartItem) {
    var qtyWrap = row.querySelector(".rebuy-cart__flyout-item-quantity");
    if (!qtyWrap) return;

    var qty = cartItem
      ? Number(cartItem.quantity) || 0
      : parseQtyFromQuantityWidget(row);
    var text = formatBundleLineQty(qty);

    var widget = qtyWrap.querySelector(
      ".rebuy-cart__flyout-item-quantity-widget",
    );
    if (widget) widget.remove();

    var label = qtyWrap.querySelector(".lsg-rebuy-bundle-line-qty");
    if (!label) {
      label = document.createElement("span");
      label.className =
        "lsg-rebuy-bundle-line-qty rebuy-cart__stay-bundle-row__qty";
      qtyWrap.appendChild(label);
    }
    label.textContent = text;
    row.classList.add("lsg-rebuy-bundle-qty-readonly");
  }

  /**
   * @param {HTMLElement} flyout
   * @param {any[]} cartItems
   */
  function updateBundleLineQuantities(flyout, cartItems) {
    var usedCartItemIndexes = {};
    flyout.querySelectorAll(".rebuy-cart__flyout-item").forEach(function (row) {
      if (!isBundleFlavorRow(row)) return;
      var cartItem = findCartItemForFlyoutRow(
        row,
        cartItems,
        usedCartItemIndexes,
      );
      replaceBundleLineQuantity(row, cartItem);
    });
  }

  /** Find cart JSON line representing this flyout bundle parent row. */
  /** @returns {Record<string, any> | null} */
  function findBundleParentCartItem(bidNorm, cartItems) {
    for (var i = 0; i < cartItems.length; i++) {
      var item = cartItems[i];
      var p = item.properties;
      if (!p || typeof p !== "object") continue;
      if (normBid(p.bundle_id) !== bidNorm) continue;
      var isParent = p.bundle_parent === true || p.bundle_parent === "true";
      if (isParent) return item;
    }
    return null;
  }

  /** @param {HTMLElement} li @param {any[]} cartItems @returns {string} */
  function bundleBoxesCountForRow(li, cartItems) {
    var own = getFlyoutProp(li, "bundle_boxes");
    if (own) return own;

    var bidNorm = normBid(getFlyoutProp(li, "bundle_id"));
    if (!bidNorm) return "";

    for (var i = 0; i < cartItems.length; i++) {
      var item = cartItems[i];
      var p = item.properties;
      if (!p || typeof p !== "object") continue;
      if (normBid(p.bundle_id) !== bidNorm) continue;
      if (p.bundle_boxes != null && String(p.bundle_boxes).trim() !== "") {
        return String(p.bundle_boxes).trim();
      }
    }

    var parent = findBundleParentCartItem(bidNorm, cartItems);
    if (
      parent &&
      parent.properties &&
      parent.properties.bundle_boxes != null &&
      String(parent.properties.bundle_boxes).trim() !== ""
    ) {
      return String(parent.properties.bundle_boxes).trim();
    }

    return "";
  }

  /** @param {HTMLElement} li @param {any[]} cartItems */
  function injectBundleBoxesLabel(li, cartItems) {
    li.querySelectorAll("." + BUNDLE_BOXES_LABEL_CLASS).forEach(function (el) {
      el.remove();
    });

    var count = bundleBoxesCountForRow(li, cartItems);
    if (!count) return;

    if (normBid(getFlyoutProp(li, "bundle_id")) === "") return;

    var info = li.querySelector(".rebuy-cart__flyout-item-info");
    if (!info) return;

    var variantEl = info.querySelector(".rebuy-cart__flyout-item-variant-title");
    var anchor =
      variantEl || info.querySelector(".rebuy-cart__flyout-item-product-title");
    if (!anchor) return;

    var label = document.createElement("div");
    label.className = BUNDLE_BOXES_LABEL_CLASS;
    label.textContent = applyCountTemplate(lsgStrings().bundleBoxesTpl, count);
    anchor.insertAdjacentElement("afterend", label);
  }

  /** Discount chip copy for bundle parent line. */
  /** @returns {string} */
  function discountLabelFromCartItem(item) {
    var allocs = item.line_level_discount_allocations;
    if (!allocs || !allocs.length) return "";
    var sumCents = 0;
    var titles = [];
    for (var i = 0; i < allocs.length; i++) {
      var a = allocs[i];
      var amt = parseFloat(String(a.amount)) || 0;
      sumCents += amt;
      var app = a.discount_application;
      var t = app && app.title ? String(app.title).trim() : "";
      if (t && titles.indexOf(t) === -1) titles.push(t);
    }
    if (titles.length === 1 && titles[0]) return titles[0];
    if (sumCents > 0) return "-" + formatMoneyCents(sumCents);
    return "";
  }

  /** @param {HTMLSelectElement} select @returns {number} */
  function subscriptionDiscountPercentFromSelect(select) {
    var row = select.closest(".rebuy-cart__flyout-item");
    if (!row) return 0;
    return subscriptionDiscountPercent(row);
  }

  /** @returns {number} */
  function subscriptionDiscountPercent(row) {
    var selected = row.querySelector(
      ".rebuy-cart__flyout-item-subscription select option:checked",
    );
    if (!selected) return 0;

    var value = String(selected.value || "").toLowerCase();
    if (value === "onetime" || value.indexOf("try") !== -1) return 0;

    var label = [
      selected.textContent || "",
      selected.getAttribute("label") || "",
      selected.parentElement
        ? selected.parentElement.getAttribute("label") || ""
        : "",
    ].join(" ");

    if (/try\s*it\s*once|one[-\s]?time/i.test(label)) return 0;

    var match = label.match(/save\s+(\d+(?:\.\d+)?)%/i);
    return match ? Number(match[1]) || 0 : 0;
  }

  /** @param {any} item */
  function isBundleFlavorCartItem(item) {
    var p = item.properties;
    if (!p || typeof p !== "object") return false;
    if (p.bundle_parent === true || p.bundle_parent === "true") return false;
    return normBid(p.bundle_id) !== "";
  }

  /** Subscription pricing/UI only when every flavor line in the bundle has a selling plan. */
  /** @param {any[]} bundleItems */
  function isBundleFullySubscription(bundleItems) {
    var flavorCount = 0;
    for (var i = 0; i < bundleItems.length; i++) {
      if (!isBundleFlavorCartItem(bundleItems[i])) continue;
      flavorCount++;
      if (!bundleItems[i].selling_plan_allocation) return false;
    }
    if (flavorCount > 0) return true;
    for (var j = 0; j < bundleItems.length; j++) {
      if (!bundleItems[j].selling_plan_allocation) return false;
    }
    return bundleItems.length > 0;
  }

  /** @param {any[]} bundleItems */
  function findBundleItemWithSellingPlan(bundleItems) {
    for (var i = 0; i < bundleItems.length; i++) {
      if (bundleItems[i].selling_plan_allocation) return bundleItems[i];
    }
    return null;
  }

  /** @param {any[]} bundleItems */
  function bundleSubscriptionPercentFromCart(bundleItems) {
    var subItem = findBundleItemWithSellingPlan(bundleItems);
    if (!subItem) return 0;

    var spa = subItem.selling_plan_allocation || {};
    var adjustments = spa.price_adjustments;
    if (adjustments && adjustments.length) {
      for (var a = 0; a < adjustments.length; a++) {
        var adj = adjustments[a];
        if (
          adj &&
          String(adj.value_type || "").toLowerCase() === "percentage" &&
          adj.value != null
        ) {
          var pct = Number(adj.value);
          if (pct > 0) return pct;
        }
      }
    }

    var plan = spa.selling_plan || {};
    var name = String(plan.name || "");
    var match = name.match(/(\d+(?:\.\d+)?)\s*%/i);
    if (match) return Number(match[1]) || 10;

    return 10;
  }

  /** @param {HTMLSelectElement} select */
  function dedupeSubscriptionSelect(select) {
    if (!select || !select.options || select.options.length === 0) return;

    var seen = {};
    var selectedValue = select.value;

    for (var i = select.options.length - 1; i >= 0; i--) {
      var opt = select.options[i];
      var key = String(opt.value || opt.textContent || "")
        .trim()
        .toLowerCase();
      if (!key) continue;
      if (seen[key]) {
        opt.remove();
        continue;
      }
      seen[key] = true;
    }

    select.querySelectorAll("optgroup").forEach(function (og) {
      if (!og.querySelector("option")) og.remove();
    });

    if (selectedValue) {
      for (var j = 0; j < select.options.length; j++) {
        if (select.options[j].value === selectedValue) {
          select.value = selectedValue;
          select.options[j].selected = true;
          break;
        }
      }
    }
  }

  /** @param {ParentNode | null} [root] */
  function dedupeSubscriptionSelectsIfNeeded(root) {
    var scope =
      root ||
      document.querySelector(".rebuy-cart__flyout") ||
      document;
    scope
      .querySelectorAll(".rebuy-cart__flyout-item-subscription select")
      .forEach(function (select) {
        dedupeSubscriptionSelect(/** @type {HTMLSelectElement} */ (select));
      });
  }

  function dedupeSubscriptionSelectsSoon() {
    if (dedupeSoonTimer) clearTimeout(dedupeSoonTimer);
    if (dedupePassTimer) clearTimeout(dedupePassTimer);
    dedupeSoonTimer = setTimeout(function () {
      dedupeSoonTimer = null;
      dedupeSubscriptionSelectsIfNeeded(null);
    }, 0);
    dedupePassTimer = setTimeout(function () {
      dedupePassTimer = null;
      dedupeSubscriptionSelectsIfNeeded(null);
    }, 120);
  }

  /** @param {HTMLElement} flyout */
  function dedupeFlyoutSubscriptionSelects(flyout) {
    dedupeSubscriptionSelectsIfNeeded(flyout);
  }

  /** @param {MutationRecord} mut */
  function mutationTouchesSubscriptionSelect(mut) {
    if (mut.type === "childList") {
      for (var i = 0; i < mut.addedNodes.length; i++) {
        var n = mut.addedNodes[i];
        if (n.nodeType !== 1) continue;
        var el = /** @type {Element} */ (n);
        if (
          el.matches &&
          (el.matches("option") ||
            el.matches("select.rebuy-select") ||
            el.matches(".rebuy-cart__flyout-item-subscription"))
        ) {
          return true;
        }
        if (
          el.querySelector &&
          el.querySelector(
            ".rebuy-cart__flyout-item-subscription select, option",
          )
        ) {
          return true;
        }
      }
    }
    var t = mut.target;
    if (t instanceof Element && t.closest) {
      if (t.closest(".rebuy-cart__flyout-item-subscription")) return true;
    }
    return false;
  }

  function ensureSubscriptionSelectObserver() {
    if (subscriptionDedupeObserverStarted) return;
    var root =
      document.querySelector(CART_ITEMS_SEL) ||
      document.querySelector(".rebuy-cart__flyout");
    if (!root) return;
    subscriptionDedupeObserverStarted = true;
    new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        if (!mutationTouchesSubscriptionSelect(mutations[m])) continue;
        if (dedupeMutTimer) clearTimeout(dedupeMutTimer);
        dedupeMutTimer = setTimeout(function () {
          dedupeMutTimer = null;
          dedupeSubscriptionSelectsSoon();
        }, 50);
        break;
      }
    }).observe(root, { childList: true, subtree: true });
  }

  /**
   * @param {HTMLSelectElement} select
   * @param {string | null} planNameLower
   * @param {string} [selectValue]
   */
  function applySubscriptionSelectionToSelect(select, planNameLower, selectValue) {
    var value = selectValue != null ? String(selectValue) : "";
    if (
      !planNameLower &&
      (value.toLowerCase() === "onetime" || value === "")
    ) {
      var onetimeOpt = select.querySelector('option[value="onetime"]');
      if (onetimeOpt) {
        onetimeOpt.selected = true;
        select.value = "onetime";
      }
      return;
    }

    var planName = planNameLower ? String(planNameLower) : "";
    var valNorm = value.toLowerCase();
    var matched = false;

    select.querySelectorAll("option").forEach(function (opt) {
      if (matched) return;
      var val = String(opt.value || "").toLowerCase();
      if (val === "onetime") return;

      var text = String(opt.textContent || "").toLowerCase();
      if (
        (valNorm && (val === valNorm || text.indexOf(valNorm) !== -1 || valNorm.indexOf(text) !== -1)) ||
        (planName &&
          (text.indexOf(planName) !== -1 ||
            planName.indexOf(text) !== -1 ||
            (val && (val.indexOf(planName) !== -1 || planName.indexOf(val) !== -1))))
      ) {
        opt.selected = true;
        select.value = opt.value;
        matched = true;
      }
    });

    if (!matched) {
      var subOpt = select.querySelector(
        'optgroup[label*="Subscribe"] option, optgroup[label*="Save"] option',
      );
      if (subOpt) {
        subOpt.selected = true;
        select.value = subOpt.value;
      }
    }
  }

  /** @param {HTMLSelectElement} select @param {string} value */
  function setSubscriptionSelectValue(select, value) {
    applySubscriptionSelectionToSelect(select, null, value);
  }

  /**
   * @param {HTMLElement} flyout
   * @param {string} bidNorm
   * @param {HTMLSelectElement} sourceSelect
   */
  /**
   * @param {HTMLElement} flyout
   * @param {string} bidNorm
   * @param {string} value
   */
  function syncBundleSubscriptionSelectsFromValue(flyout, bidNorm, value) {
    if (bundleSubSyncingUi) return;
    bundleSubSyncingUi = true;

    flyout.querySelectorAll(".rebuy-cart__flyout-item").forEach(function (row) {
      if (normBid(getFlyoutProp(row, "bundle_id")) !== bidNorm) return;

      var select = row.querySelector(
        ".rebuy-cart__flyout-item-subscription select",
      );
      if (!select) return;

      dedupeSubscriptionSelect(/** @type {HTMLSelectElement} */ (select));
      setSubscriptionSelectValue(/** @type {HTMLSelectElement} */ (select), value);
    });

    bundleSubSyncingUi = false;
  }

  /** @param {HTMLElement} flyout @param {string} bidNorm @param {HTMLSelectElement} sourceSelect */
  function syncBundleSubscriptionSelectsFromRow(flyout, bidNorm, sourceSelect) {
    syncBundleSubscriptionSelectsFromValue(flyout, bidNorm, sourceSelect.value);
  }

  /**
   * @param {HTMLElement} flyout
   * @param {string} bidNorm
   * @returns {string}
   */
  function getDefaultBundleSubscriptionSelectValue(flyout, bidNorm) {
    /** @type {HTMLSelectElement | null} */
    var found = null;
    flyout.querySelectorAll(".rebuy-cart__flyout-item").forEach(function (row) {
      if (found || normBid(getFlyoutProp(row, "bundle_id")) !== bidNorm) return;
      found = row.querySelector(
        ".rebuy-cart__flyout-item-subscription select",
      );
    });
    if (!found) return "";
    dedupeSubscriptionSelect(found);
    var subOpt = found.querySelector(
      'optgroup[label*="Subscribe"] option, optgroup[label*="Save"] option',
    );
    return subOpt ? String(subOpt.value || "") : "";
  }

  /** @param {HTMLElement} flyout @param {string} bidNorm @returns {HTMLElement | null} */
  function findFlyoutRowForBid(flyout, bidNorm) {
    var rows = flyout.querySelectorAll(".rebuy-cart__flyout-item");
    for (var i = 0; i < rows.length; i++) {
      if (normBid(getFlyoutProp(rows[i], "bundle_id")) === bidNorm) {
        return /** @type {HTMLElement} */ (rows[i]);
      }
    }
    return null;
  }

  /** @param {HTMLElement} row @returns {string} */
  function getProductHandleFromFlyoutRow(row) {
    var titleLink = row.querySelector(".rebuy-cart__flyout-item-product-title");
    var href = titleLink ? titleLink.getAttribute("href") || "" : "";
    var handleMatch = href.match(/\/products\/([^?#/]+)/);
    return handleMatch ? handleMatch[1] : "";
  }

  /**
   * @param {HTMLElement} flyout
   * @param {string} bidNorm
   * @returns {HTMLElement[]}
   */
  function getBundleFlavorRows(flyout, bidNorm) {
    /** @type {HTMLElement[]} */
    var flavorRows = [];
    flyout.querySelectorAll(".rebuy-cart__flyout-item").forEach(function (row) {
      if (normBid(getFlyoutProp(row, "bundle_id")) !== bidNorm) return;
      if (isBundleParentRow(row)) return;
      flavorRows.push(row);
    });
    return flavorRows;
  }

  /**
   * @param {HTMLElement} flyout
   * @param {string} bidNorm
   * @returns {boolean}
   */
  function bundleAllRowsShowUpgradeButton(flyout, bidNorm) {
    var flavorRows = getBundleFlavorRows(flyout, bidNorm);
    if (!flavorRows.length) return false;

    for (var i = 0; i < flavorRows.length; i++) {
      var sub = flavorRows[i].querySelector(".rebuy-cart__flyout-item-subscription");
      if (!sub) return false;
      if (sub.querySelector("select")) return false;
      if (!sub.querySelector("button.rebuy-button")) return false;
    }
    return true;
  }

  /** @param {any} product */
  function filterStaySellingPlanGroups(product) {
    var groups = (product && product.selling_plan_groups) || [];
    /** @type {any[]} */
    var filtered = [];
    for (var i = 0; i < groups.length; i++) {
      if (String(groups[i].app_id) === "5859381") filtered.push(groups[i]);
    }
    return filtered.length ? filtered : groups;
  }

  /** @param {any[]} plans */
  function subscriptionSavePercentFromPlans(plans) {
    for (var p = 0; p < plans.length; p++) {
      var adjustments = plans[p].price_adjustments || [];
      for (var a = 0; a < adjustments.length; a++) {
        var adj = adjustments[a];
        if (
          adj &&
          String(adj.value_type || "").toLowerCase() === "percentage" &&
          adj.value > 0
        ) {
          return Number(adj.value) || 10;
        }
      }
    }
    return 10;
  }

  /** @param {any} product @returns {HTMLSelectElement} */
  function createBundleSubscriptionSelectFromProduct(product) {
    var select = document.createElement("select");
    select.setAttribute("aria-label", "Subscription delivery frequency");
    select.className = "rebuy-select muted";

    var otpGroup = document.createElement("optgroup");
    otpGroup.label = "Pay Full Price";
    var onetimeOpt = document.createElement("option");
    onetimeOpt.value = "onetime";
    onetimeOpt.textContent = "Try once";
    otpGroup.appendChild(onetimeOpt);
    select.appendChild(otpGroup);

    var planGroups = filterStaySellingPlanGroups(product);
    for (var g = 0; g < planGroups.length; g++) {
      var group = planGroups[g];
      var plans = group.selling_plans || [];
      if (!plans.length) continue;

      var savePct = subscriptionSavePercentFromPlans(plans);
      var subGroup = document.createElement("optgroup");
      var groupName = String(group.name || "").trim();
      subGroup.label =
        groupName && /save/i.test(groupName)
          ? groupName
          : "Subscribe and Save " + savePct + "%";

      for (var p = 0; p < plans.length; p++) {
        var plan = plans[p];
        var planName = String(plan.name || "").trim();
        if (!planName) continue;
        var opt = document.createElement("option");
        opt.value = planName;
        opt.textContent = planName;
        subGroup.appendChild(opt);
      }

      if (subGroup.querySelector("option")) select.appendChild(subGroup);
    }

    select.value = "onetime";
    return select;
  }

  /**
   * @param {HTMLElement} row
   * @param {HTMLSelectElement} templateSelect
   */
  function injectSubscriptionSelectIntoRow(row, templateSelect) {
    var sub = row.querySelector(".rebuy-cart__flyout-item-subscription");
    if (!sub || sub.querySelector("select")) return;

    var select = /** @type {HTMLSelectElement} */ (templateSelect.cloneNode(true));
    select.value = "onetime";

    var btn = sub.querySelector("button.rebuy-button");
    if (btn) btn.remove();
    sub.appendChild(select);
    dedupeSubscriptionSelect(select);
  }

  /**
   * When every bundle flavor shows only the upgrade button, inject Rebuy-style
   * frequency selects on all rows (one product fetch per handle).
   * @param {HTMLElement} flyout
   * @param {string} bidNorm
   * @returns {Promise<void>}
   */
  function revealBundleSubscriptionSelectsForBid(flyout, bidNorm) {
    var flavorRows = getBundleFlavorRows(flyout, bidNorm);
    if (!flavorRows.length) return Promise.resolve();

    var handle = getProductHandleFromFlyoutRow(flavorRows[0]);
    if (!handle) return Promise.resolve();

    return fetchProductJson(handle).then(function (product) {
      if (!product) return;
      var templateSelect = createBundleSubscriptionSelectFromProduct(product);
      flavorRows.forEach(function (row) {
        injectSubscriptionSelectIntoRow(row, templateSelect);
      });
      ensureBundleSubscriptionSelectsOnAllRows(flyout, bidNorm);
    });
  }

  /**
   * Every bundle flavor row gets a frequency select (clone from an existing row).
   * @param {HTMLElement} flyout
   * @param {string} bidNorm
   * @returns {Promise<void>}
   */
  function ensureBundleSubscriptionSelectsOnAllRows(flyout, bidNorm) {
    var flavorRows = getBundleFlavorRows(flyout, bidNorm);
    if (!flavorRows.length) return Promise.resolve();

    /** @type {HTMLSelectElement | null} */
    var template = null;
    var sourceValue = "onetime";
    for (var i = 0; i < flavorRows.length; i++) {
      var existing = flavorRows[i].querySelector(
        ".rebuy-cart__flyout-item-subscription select",
      );
      if (existing) {
        template = /** @type {HTMLSelectElement} */ (existing);
        sourceValue = template.value;
        break;
      }
    }

    var needsFetch = false;
    for (var r = 0; r < flavorRows.length; r++) {
      var row = flavorRows[r];
      var sub = row.querySelector(".rebuy-cart__flyout-item-subscription");
      if (!sub) continue;

      if (!sub.querySelector("select")) {
        if (template) {
          injectSubscriptionSelectIntoRow(row, template);
        } else {
          needsFetch = true;
        }
      }

      var btn = sub.querySelector("button.rebuy-button");
      if (btn) btn.remove();
    }

    if (needsFetch) {
      return revealBundleSubscriptionSelectsForBid(flyout, bidNorm);
    }

    if (template) {
      syncBundleSubscriptionSelectsFromValue(flyout, bidNorm, sourceValue);
    }
    return Promise.resolve();
  }

  /**
   * @param {HTMLElement} flyout
   * @param {any[]} cartItems
   * @returns {Promise<boolean>}
   */
  function repairAllMixedBundleSubscriptions(flyout, cartItems) {
    if (bundleSubCartUpdating || !flyout) return Promise.resolve(false);

    /** @type {Record<string, any[]>} */
    var flavorsByBid = {};
    for (var i = 0; i < cartItems.length; i++) {
      var item = cartItems[i];
      if (!isBundleFlavorCartItem(item)) continue;
      var bid = normBid(item.properties.bundle_id);
      if (!flavorsByBid[bid]) flavorsByBid[bid] = [];
      flavorsByBid[bid].push(item);
    }

    /** @type {string[]} */
    var bidsToRepair = [];
    Object.keys(flavorsByBid).forEach(function (bidNorm) {
      var flavors = flavorsByBid[bidNorm];
      if (flavors.length < 2) return;
      var subCount = 0;
      for (var f = 0; f < flavors.length; f++) {
        if (flavors[f].selling_plan_allocation) subCount++;
      }
      if (subCount > 0 && subCount < flavors.length) bidsToRepair.push(bidNorm);
    });

    if (!bidsToRepair.length) return Promise.resolve(false);

    var index = 0;
    function next() {
      if (index >= bidsToRepair.length) return Promise.resolve(true);
      var bidNorm = bidsToRepair[index++];
      var row = findFlyoutRowForBid(flyout, bidNorm);
      if (!row) return next();
      return updateBundleSubscriptionInCart(bidNorm, "onetime", row).then(next);
    }
    return next();
  }

  /**
   * @param {any} lineRef
   * @returns {{ bidNorm: string, variantId: number, isParent: boolean }}
   */
  function bundleLineCartIdentity(lineRef) {
    var p = lineRef.properties || {};
    return {
      bidNorm: normBid(p.bundle_id),
      variantId: Number(lineRef.variant_id) || 0,
      isParent: p.bundle_parent === true || p.bundle_parent === "true",
    };
  }

  /**
   * @param {any} cart
   * @param {any} lineRef
   * @returns {any | null}
   */
  function findBundleLineInCart(cart, lineRef) {
    var id = bundleLineCartIdentity(lineRef);
    if (!id.bidNorm || !id.variantId) return null;
    var items = cart && cart.items ? cart.items : [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var itemId = bundleLineCartIdentity(item);
      if (itemId.bidNorm !== id.bidNorm) continue;
      if (itemId.variantId !== id.variantId) continue;
      if (itemId.isParent !== id.isParent) continue;
      return item;
    }
    return null;
  }

  /**
   * @param {any} item
   * @param {number | null} planId
   */
  function lineNeedsSellingPlanChange(item, planId) {
    if (planId == null) return !!item.selling_plan_allocation;
    var alloc = item.selling_plan_allocation;
    if (!alloc) return true;
    var currentId =
      alloc.selling_plan && alloc.selling_plan.id != null
        ? Number(alloc.selling_plan.id)
        : null;
    return currentId !== Number(planId);
  }

  /**
   * @param {string} lineKey
   * @param {number} quantity
   * @param {number | null} planId
   */
  function changeCartLineSellingPlan(lineKey, quantity, planId) {
    /** @type {Record<string, unknown>} */
    var body = { id: lineKey, quantity: quantity };
    if (planId != null && planId !== "") {
      body.selling_plan = planId;
    } else {
      body.selling_plan = null;
    }
    return fetch(cartChangeUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var err = new Error("cart change failed");
          err.cart = data;
          throw err;
        }
        return data;
      });
    });
  }

  /**
   * @param {any[]} lines
   * @param {number | null} planId
   * @param {any} initialCart
   * @returns {Promise<any>}
   */
  function changeBundleLinesSellingPlanSequential(lines, planId, initialCart) {
    /** @type {any[]} */
    var queue = lines.slice();

    /**
     * @param {any} cart
     * @returns {Promise<any>}
     */
    function step(cart) {
      if (!queue.length) return Promise.resolve(cart);
      var ref = queue.shift();
      var item = findBundleLineInCart(cart, ref);
      if (!item) return step(cart);
      if (!lineNeedsSellingPlanChange(item, planId)) return step(cart);

      return changeCartLineSellingPlan(
        item.key,
        Number(item.quantity) || 1,
        planId,
      )
        .then(function (updatedCart) {
          reapplyBundleSubRowMarkers();
          var nextCart =
            updatedCart && updatedCart.items ? updatedCart : cart;
          return step(nextCart);
        })
        .catch(function () {
          return fetchCartJson().then(function (fresh) {
            var nextCart = fresh || cart;
            var retryItem = findBundleLineInCart(nextCart, ref);
            if (
              !retryItem ||
              !lineNeedsSellingPlanChange(retryItem, planId)
            ) {
              return step(nextCart);
            }
            return changeCartLineSellingPlan(
              retryItem.key,
              Number(retryItem.quantity) || 1,
              planId,
            )
              .then(function (updatedCart) {
                reapplyBundleSubRowMarkers();
                return step(
                  updatedCart && updatedCart.items ? updatedCart : nextCart,
                );
              })
              .catch(function () {
                return step(nextCart);
              });
          });
        });
    }

    return step(initialCart || { items: [] });
  }

  /**
   * @param {string} bidNorm
   * @param {any[]} cartItems
   * @param {number | null} planId
   * @returns {any[]}
   */
  function bundleLinesNeedingPlanFix(bidNorm, cartItems, planId) {
    /** @type {any[]} */
    var fix = [];
    for (var i = 0; i < cartItems.length; i++) {
      var item = cartItems[i];
      var p = item.properties;
      if (!p || typeof p !== "object" || normBid(p.bundle_id) !== bidNorm) {
        continue;
      }
      if (lineNeedsSellingPlanChange(item, planId)) fix.push(item);
    }
    return fix;
  }

  /**
   * Update every bundle line selling plan in place (no cart/update zeroing).
   * @param {string} bidNorm
   * @param {any} cart
   * @param {number | null} planId
   * @param {{ selectValue: string, subPercent: number }} pricingIntent
   * @returns {Promise<any>}
   */
  function syncBundleSellingPlanViaChange(bidNorm, cart, planId, pricingIntent) {
    var bundle = getBundleLinesFromCart(bidNorm, cart);
    if (!bundle.lines.length) return Promise.resolve(cart);

    reapplyBundleSubRowMarkers();
    return changeBundleLinesSellingPlanSequential(bundle.lines, planId, cart)
      .then(function (cartAfterPass) {
        reapplyBundleSubRowMarkers();
        var cartAfter =
          cartAfterPass && cartAfterPass.items ? cartAfterPass : null;
        if (!cartAfter) {
          return fetchCartJson().then(function (fetched) {
            return fetched || cart;
          });
        }
        return cartAfter;
      })
      .then(function (cartAfter) {
        if (!cartAfter) return cart;
        if (
          cartMatchesPendingSubscription(
            bidNorm,
            cartAfter.items || [],
            pricingIntent,
          )
        ) {
          return cartAfter;
        }
        var retryLines = bundleLinesNeedingPlanFix(
          bidNorm,
          cartAfter.items || [],
          planId,
        );
        if (!retryLines.length) return cartAfter;
        return changeBundleLinesSellingPlanSequential(
          retryLines,
          planId,
          cartAfter,
        ).then(function (cartRetry) {
          if (cartRetry && cartRetry.items) return cartRetry;
          return fetchCartJson();
        });
      })
      .then(function (cartFinal) {
        return cartFinal || cart;
      });
  }

  /**
   * @param {string} bidNorm
   * @param {any} cart
   * @returns {{ lines: any[], updates: Record<string, number> }}
   */
  function getBundleLinesFromCart(bidNorm, cart) {
    /** @type {any[]} */
    var lines = [];
    /** @type {Record<string, number>} */
    var updates = {};
    var items = cart.items || [];

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var p = item.properties;
      if (!p || typeof p !== "object") continue;
      if (normBid(p.bundle_id) !== bidNorm) continue;
      lines.push(item);
      updates[item.key] = 0;
    }

    return { lines: lines, updates: updates };
  }

  /**
   * Remove-and-re-add only when crossing OTP/subscribe boundary (re-add clears lines briefly).
   * Plan frequency changes (14d → 30d) use cart/change.js and keep lines in place.
   * @param {any} cart
   * @param {string} bidNorm
   * @param {number | null} planId
   */
  function bundleNeedsSellingPlanReadd(cart, bidNorm, planId) {
    var bundle = getBundleLinesFromCart(bidNorm, cart);
    var lines = bundle.lines;
    if (!lines.length) return false;

    if (planId == null) {
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].selling_plan_allocation) return true;
      }
      return false;
    }

    for (var j = 0; j < lines.length; j++) {
      if (!lines[j].selling_plan_allocation) return true;
    }
    return false;
  }

  /**
   * @param {any[]} lines
   * @param {number | null} planId
   * @returns {Record<string, unknown>[]}
   */
  function buildBundleAddItemsFromLines(lines, planId) {
    /** @type {Record<string, unknown>[]} */
    var addItems = [];
    for (var j = 0; j < lines.length; j++) {
      var line = lines[j];
      var props = line.properties || {};
      /** @type {Record<string, string>} */
      var nextProps = {};
      Object.keys(props).forEach(function (key) {
        var val = props[key];
        if (val != null) nextProps[key] = String(val);
      });
      /** @type {Record<string, unknown>} */
      var addItem = {
        id: line.variant_id,
        quantity: Number(line.quantity) || 1,
        properties: nextProps,
      };
      if (planId != null) addItem.selling_plan = planId;
      addItems.push(addItem);
    }
    return addItems;
  }

  /**
   * @param {string} bidNorm
   * @param {any} cart
   * @param {number | null} planId
   * @returns {Promise<any>}
   */
  function convertBundleSellingPlanByReadd(bidNorm, cart, planId) {
    var bundle = getBundleLinesFromCart(bidNorm, cart);
    var lines = bundle.lines;
    var updates = bundle.updates;
    if (!lines.length) return Promise.resolve(cart);

    return fetch(cartUpdateUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            var err = new Error("cart update failed");
            err.cart = data;
            throw err;
          }
          return data;
        });
      })
      .then(function () {
        var addItems = buildBundleAddItemsFromLines(lines, planId);
        return fetch(cartAddUrl(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "same-origin",
          body: JSON.stringify({ items: addItems }),
        }).then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) {
              var addErr = new Error("cart add failed");
              addErr.cart = data;
              throw addErr;
            }
            return data;
          });
        });
      })
      .then(function () {
        return fetch(cartJsUrl(), {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        }).then(function (r) {
          return r.json();
        });
      });
  }

  /**
   * @param {string} bidNorm
   * @param {any} cart
   * @returns {Promise<any>}
   */
  function convertBundleToOtpByReadd(bidNorm, cart) {
    return convertBundleSellingPlanByReadd(bidNorm, cart, null);
  }

  /**
   * @param {string} bidNorm
   * @param {any} cart
   * @param {number} planId
   * @returns {Promise<any>}
   */
  function convertBundleToSubscriptionByReadd(bidNorm, cart, planId) {
    return convertBundleSellingPlanByReadd(bidNorm, cart, planId);
  }

  /**
   * @param {string} bidNorm
   * @param {string} selectValue
   * @param {HTMLElement} sourceRow
   * @returns {Promise<void>}
   */
  function updateBundleSubscriptionInCart(bidNorm, selectValue, sourceRow) {
    if (!sourceRow) return Promise.resolve();
    var startedHere = !bundleSubCartUpdating;
    if (startedHere) {
      bundleSubCartUpdating = true;
      bundleSubSuppressScheduleUntil = Date.now() + 8000;
    }
    /** @type {HTMLElement | null} */
    var flyout = document.querySelector(".rebuy-cart__flyout");
    var pricingApplied = false;

    var pending = getPendingBundleSubscription(bidNorm);
    var sourceSelect = sourceRow.querySelector(
      ".rebuy-cart__flyout-item-subscription select",
    );
    var pricingIntent = pending || {
      selectValue: selectValue,
      subPercent: isSelectValueOnetime(selectValue)
        ? 0
        : sourceSelect
          ? subscriptionDiscountPercentFromSelect(
              /** @type {HTMLSelectElement} */ (sourceSelect),
            )
          : 10,
    };
    /** @type {Record<string, { selectValue: string, subPercent: number }>} */
    var pricingIntentByBid = {};
    pricingIntentByBid[bidNorm] = pricingIntent;
    if (startedHere) {
      beginBundleSubMutationUi(flyout, bidNorm, pricingIntentByBid);
      if (flyout && lastCartItems.length && sourceSelect) {
        repaintBundlePricesForSelect(
          flyout,
          lastCartItems,
          bidNorm,
          /** @type {HTMLSelectElement} */ (sourceSelect),
        );
      }
    }

    var titleLink = sourceRow.querySelector(
      ".rebuy-cart__flyout-item-product-title",
    );
    var href = titleLink ? titleLink.getAttribute("href") || "" : "";
    var handleMatch = href.match(/\/products\/([^?#/]+)/);
    var handle = handleMatch ? handleMatch[1] : "";

    return resolveSellingPlanIdForSelectValue(handle, selectValue)
      .then(function (planId) {
        return fetchCartJson().then(function (cart) {
          if (!cart) throw new Error("cart fetch failed");
          return syncBundleSellingPlanViaChange(
            bidNorm,
            cart,
            planId,
            pricingIntent,
          );
        });
      })
      .then(function (cart) {
        if (!cart) return;
        if (flyout) {
          return finishBundleSubscriptionUpdate(
            flyout,
            cart,
            bidNorm,
            pricingIntent,
          ).then(function () {
            pricingApplied = true;
          });
        }
        dispatchCartUpdatedEvents(cart);
        bundleSubCartUpdating = false;
      })
      .catch(function () {
        bundleSubHydrateQueued = true;
      })
      .finally(function () {
        if (!pricingApplied) {
          releaseBundleSubMutationUi();
          bundleSubCartUpdating = false;
          if (bundleSubHydrateQueued) {
            bundleSubHydrateQueued = false;
            bundleSubHydrateSkipRepair = true;
            schedule();
          }
        }
      });
  }

  /**
   * @param {HTMLElement} flyout
   * @param {string} bidNorm
   * @param {any[]} cartItems
   */
  function syncBundleSubscriptionSelects(flyout, bidNorm, cartItems) {
    ensureBundleSubscriptionSelectsOnAllRows(flyout, bidNorm);

    var pending = getPendingBundleSubscription(bidNorm);
    if (
      pending &&
      !cartMatchesPendingSubscription(bidNorm, cartItems, pending)
    ) {
      syncBundleSubscriptionSelectsFromValue(
        flyout,
        bidNorm,
        pending.selectValue,
      );
      return;
    }

    var bundle = bundleCartLines(bidNorm, cartItems);
    var isSub = isBundleFullySubscription(bundle.items);
    var subItem = findBundleItemWithSellingPlan(bundle.items);
    var plan = subItem
      ? (subItem.selling_plan_allocation || {}).selling_plan || {}
      : null;
    var planName = plan ? String(plan.name || "").toLowerCase() : "";

    flyout.querySelectorAll(".rebuy-cart__flyout-item").forEach(function (row) {
      if (normBid(getFlyoutProp(row, "bundle_id")) !== bidNorm) return;

      var select = row.querySelector(
        ".rebuy-cart__flyout-item-subscription select",
      );
      if (!select) return;

      dedupeSubscriptionSelect(/** @type {HTMLSelectElement} */ (select));

      if (!isSub) {
        setSubscriptionSelectValue(/** @type {HTMLSelectElement} */ (select), "onetime");
        return;
      }

      applySubscriptionSelectionToSelect(
        /** @type {HTMLSelectElement} */ (select),
        planName,
        "",
      );
    });
  }

  /** @returns {Record<string, number> | null} */
  function readTierDiscountsMap() {
    var mapEl = document.getElementById("lsg-bundle-tier-discounts");
    if (mapEl) {
      try {
        return JSON.parse(mapEl.textContent);
      } catch (_err) {
        /* ignore */
      }
    }
    var cartCfg = window.LSG_REBUY_CART || {};
    if (cartCfg.tierDiscountCentsByIndex) return cartCfg.tierDiscountCentsByIndex;
    return null;
  }

  /**
   * Full retail line total for bundle OTP math (before tier + subscription).
   * Subscription lines can expose original_line_price after the selling-plan
   * discount, so reverse that discount before applying bundle tier savings.
   * @param {any} item
   * @param {number} subscriptionPercent
   * @returns {number}
   */
  function bundleLineListCents(item, subscriptionPercent) {
    var qty = Number(item.quantity) || 1;
    var finUnit = Number(item.final_price) || Number(item.price) || 0;
    var finLine = Number(item.final_line_price) || finUnit * qty;
    var isSubscriptionLine = !!item.selling_plan_allocation;
    var subscriptionMultiplier =
      isSubscriptionLine && subscriptionPercent > 0 && subscriptionPercent < 100
        ? 1 - subscriptionPercent / 100
        : 0;

    var planCompare =
      isSubscriptionLine && item.selling_plan_allocation
        ? Number(item.selling_plan_allocation.compare_at_price || 0)
        : 0;
    if (planCompare > 0) {
      var planRetailLine = planCompare * qty;
      if (planRetailLine >= finLine) return planRetailLine;
    }

    var unitRetail =
      Number(item.compare_at_price) || Number(item.variant_compare_at_price) || 0;
    var unitOriginal = Number(item.original_price) || 0;
    if (!subscriptionMultiplier && unitOriginal > unitRetail) {
      unitRetail = unitOriginal;
    }
    if (unitRetail > 0) {
      var retailLine = unitRetail * qty;
      if (retailLine >= finLine) return retailLine;
    }

    if (unitOriginal > 0) {
      var originalLine = unitOriginal * qty;
      if (subscriptionMultiplier) {
        return Math.round(originalLine / subscriptionMultiplier);
      }
      if (originalLine > finLine) return originalLine;
    }

    var origLine = Number(item.original_line_price) || 0;
    if (origLine > 0 && subscriptionMultiplier) {
      return Math.round(origLine / subscriptionMultiplier);
    }
    if (origLine > finLine) return origLine;

    var addBack = 0;
    var allocs = item.line_level_discount_allocations;
    if (allocs) {
      for (var a = 0; a < allocs.length; a++) {
        addBack += parseFloat(String(allocs[a].amount)) || 0;
      }
    }
    if (origLine > 0 && addBack > 0) return origLine + addBack;

    return finLine;
  }

  /** @param {string} boxCount */
  function tierDiscountCentsForBoxCount(boxCount) {
    var map = readTierDiscountsMap();
    if (!map) return 0;

    var cartCfg = window.LSG_REBUY_CART || {};
    var boxToTier = cartCfg.bundleBoxesToTierIndex || { 3: 1, 6: 2, 8: 3 };
    var tierKey = boxToTier[String(boxCount)] ?? boxToTier[boxCount];
    if (tierKey == null) tierKey = String(boxCount);

    var cents = map[tierKey] ?? map[String(tierKey)];
    return parseInt(cents, 10) || 0;
  }

  /**
   * @param {any[]} cartItems
   * @param {string} bidNorm
   * @param {{ selectValue?: string, subPercent?: number } | null} [uiState]
   * @returns {{ items: any[], listTotalCents: number, boxCount: string }}
   */
  function bundleCartLines(bidNorm, cartItems, uiState) {
    /** @type {any[]} */
    var items = [];
    var listTotalCents = 0;
    var boxCount = "";
    var forceOtpList =
      uiState && uiState.selectValue != null
        ? isSelectValueOnetime(uiState.selectValue)
        : false;

    for (var i = 0; i < cartItems.length; i++) {
      var item = cartItems[i];
      var p = item.properties;
      if (!p || typeof p !== "object") continue;
      if (normBid(p.bundle_id) !== bidNorm) continue;

      items.push(item);

      if (p.bundle_boxes != null && String(p.bundle_boxes).trim() !== "") {
        boxCount = String(p.bundle_boxes).trim();
      }
    }

    for (var j = 0; j < items.length; j++) {
      var linePct = forceOtpList
        ? 0
        : items[j].selling_plan_allocation
          ? bundleSubscriptionPercentFromCart([items[j]])
          : 0;
      listTotalCents += bundleLineListCents(items[j], linePct);
    }

    if (!boxCount) {
      var parent = findBundleParentCartItem(bidNorm, cartItems);
      if (
        parent &&
        parent.properties &&
        parent.properties.bundle_boxes != null
      ) {
        boxCount = String(parent.properties.bundle_boxes).trim();
      }
    }

    if (!boxCount) {
      var flavorCount = 0;
      for (var k = 0; k < items.length; k++) {
        if (isBundleFlavorCartItem(items[k])) flavorCount++;
      }
      if (flavorCount > 0) boxCount = String(flavorCount);
    }

    return { items: items, listTotalCents: listTotalCents, boxCount: boxCount };
  }

  /**
   * Match PDP bundle OTP / subscribe display (tier savings from Stay AI size labels).
   * Uses cart.js selling_plan_allocation unless uiState reflects the active select.
   * @param {any[]} cartItems
   * @param {string} bidNorm
   * @param {{ selectValue?: string, subPercent?: number } | null} [uiState]
   * @returns {{ compareCents: number | null, saleCents: number } | null}
   */
  function bundleDisplayLinePrices(cartItems, bidNorm, uiState) {
    var bundle = bundleCartLines(bidNorm, cartItems, uiState);
    if (!bundle.items.length || bundle.listTotalCents <= 0) return null;

    var tierCents = tierDiscountCentsForBoxCount(bundle.boxCount);
    var listTotal = bundle.listTotalCents;
    var saleTotal = listTotal;
    var compareTotal = null;

    if (tierCents > 0) {
      var otpSaleCents = Math.max(0, listTotal - tierCents);
      var subPct = 0;
      if (uiState && uiState.selectValue != null) {
        if (isSelectValueOnetime(uiState.selectValue)) {
          subPct = 0;
        } else {
          subPct =
            uiState.subPercent != null && uiState.subPercent > 0
              ? uiState.subPercent
              : 10;
        }
      } else if (isBundleFullySubscription(bundle.items)) {
        subPct = bundleSubscriptionPercentFromCart(bundle.items);
      }
      if (subPct > 0) {
        compareTotal = otpSaleCents;
        saleTotal = Math.round(otpSaleCents * (1 - subPct / 100));
      } else {
        compareTotal = listTotal;
        saleTotal = otpSaleCents;
      }
    } else {
      var finalTotal = 0;
      for (var j = 0; j < bundle.items.length; j++) {
        finalTotal += Number(bundle.items[j].final_line_price) || 0;
      }
      saleTotal = finalTotal;
      if (listTotal > finalTotal) compareTotal = listTotal;
    }

    return { compareCents: compareTotal, saleCents: saleTotal };
  }

  /**
   * @param {HTMLElement} flyout
   * @param {HTMLElement[]} allRows
   * @param {string} bidNorm
   * @returns {HTMLElement | null}
   */
  function findBundlePriceRowForBid(flyout, allRows, bidNorm) {
    var bundleRows = [];
    for (var i = 0; i < allRows.length; i++) {
      if (normBid(getFlyoutProp(allRows[i], "bundle_id")) === bidNorm) {
        bundleRows.push(allRows[i]);
      }
    }
    for (var j = 0; j < bundleRows.length; j++) {
      if (isBundleParentRow(bundleRows[j])) return bundleRows[j];
    }
    return bundleRows[0] || null;
  }

  /** @returns {number | null} */
  function originalLinePriceCents(cartItem, row) {
    var qty = Number(cartItem.quantity) || 1;
    var finalUnitCents = Number(cartItem.final_price || cartItem.price || 0);
    var sellingPlan = cartItem.selling_plan_allocation || {};
    var unitCandidates = [
      cartItem.compare_at_price,
      cartItem.variant_compare_at_price,
      sellingPlan.compare_at_price,
    ];

    for (var i = 0; i < unitCandidates.length; i++) {
      var unitCents = Number(unitCandidates[i] || 0);
      if (unitCents > finalUnitCents) return unitCents * qty;
    }

    if (
      Number(cartItem.original_line_price) > Number(cartItem.final_line_price)
    ) {
      return Number(cartItem.original_line_price);
    }

    var percent = subscriptionDiscountPercent(row);
    if (percent > 0 && percent < 100 && finalUnitCents > 0) {
      return Math.round(finalUnitCents / (1 - percent / 100)) * qty;
    }

    return null;
  }

  /** @returns {string} */
  function normalizeVariantTitle(value) {
    var title = String(value || "").trim();
    return title.toLowerCase() === "default title" ? "" : title;
  }

  /** @param {HTMLElement} flyout */
  function normalizeCheckoutLabels(flyout) {
    flyout
      .querySelectorAll(".rebuy-cart__checkout-button span")
      .forEach(function (span) {
        var label = (span.textContent || "")
          .replace(/\s*[→›»]\s*$/g, "")
          .trim();
        if (label) span.textContent = label;
      });
  }

  /**
   * @param {any[]} cartItems
   * @param {Record<string, { compareCents: number | null, saleCents: number }>} bundlePriceByBid
   * @returns {{ saleCents: number, compareCents: number | null }}
   */
  function computeCartDisplayTotals(cartItems, bundlePriceByBid) {
    var saleTotal = 0;
    var compareTotal = 0;
    var hasCompare = false;
    var countedBundles = {};

    for (var i = 0; i < cartItems.length; i++) {
      var item = cartItems[i];
      var p = item.properties;
      var bidNorm =
        p && typeof p === "object" ? normBid(p.bundle_id) : "";

      if (bidNorm) {
        if (countedBundles[bidNorm]) continue;
        countedBundles[bidNorm] = true;
        var bp = bundlePriceByBid[bidNorm];
        if (bp) {
          saleTotal += bp.saleCents;
          if (bp.compareCents != null && bp.compareCents > bp.saleCents) {
            compareTotal += bp.compareCents;
            hasCompare = true;
          } else {
            compareTotal += bp.saleCents;
          }
        } else {
          var finB = Number(item.final_line_price) || 0;
          var origB = Number(item.original_line_price) || finB;
          saleTotal += finB;
          compareTotal += origB;
          if (origB > finB) hasCompare = true;
        }
        continue;
      }

      var fin = Number(item.final_line_price) || 0;
      var orig = Number(item.original_line_price) || fin;
      saleTotal += fin;
      compareTotal += orig > fin ? orig : fin;
      if (orig > fin) hasCompare = true;
    }

    return {
      saleCents: saleTotal,
      compareCents:
        hasCompare && compareTotal > saleTotal ? compareTotal : null,
    };
  }

  /**
   * @param {HTMLElement} flyout
   * @param {any[]} cartItems
   * @param {Record<string, { selectValue: string, subPercent: number }> | null} [pricingIntentByBid]
   * @returns {Record<string, { compareCents: number | null, saleCents: number, label: string, priceRow: HTMLElement }>}
   */
  function buildBundlePriceMap(flyout, cartItems, pricingIntentByBid) {
    var allRows = Array.prototype.slice.call(
      flyout.querySelectorAll(".rebuy-cart__flyout-item"),
    );
    /** @type {Record<string, { compareCents: number | null, saleCents: number, label: string, priceRow: HTMLElement | null }>} */
    var bundlePriceByBid = {};
    /** @type {Record<string, boolean>} */
    var bidSeen = {};

    for (var i = 0; i < cartItems.length; i++) {
      var p = cartItems[i].properties;
      if (!p || typeof p !== "object") continue;
      var bidNorm = normBid(p.bundle_id);
      if (!bidNorm || bidSeen[bidNorm]) continue;
      bidSeen[bidNorm] = true;

      var uiState =
        (pricingIntentByBid && pricingIntentByBid[bidNorm]) ||
        resolveBundleUiStateForPricing(flyout, bidNorm);
      var bundlePrices = bundleDisplayLinePrices(cartItems, bidNorm, uiState);
      if (!bundlePrices) continue;

      syncBundleSubscriptionSelects(flyout, bidNorm, cartItems);

      var priceRow = findBundlePriceRowForBid(flyout, allRows, bidNorm);
      var parentItem = findBundleParentCartItem(bidNorm, cartItems);
      bundlePriceByBid[bidNorm] = {
        compareCents: bundlePrices.compareCents,
        saleCents: bundlePrices.saleCents,
        label: parentItem ? discountLabelFromCartItem(parentItem) : "",
        priceRow: priceRow,
      };
    }

    return bundlePriceByBid;
  }

  /**
   * @param {HTMLElement} flyout
   * @param {any[]} cartItems
   * @param {string} bidNorm
   * @param {HTMLSelectElement} select
   */
  function repaintBundlePricesForSelect(flyout, cartItems, bidNorm, select) {
    var subPct = subscriptionDiscountPercentFromSelect(select);
    var prices = bundleDisplayLinePrices(cartItems, bidNorm, {
      selectValue: select.value,
      subPercent: subPct,
    });
    if (!prices) return;

    var allRows = Array.prototype.slice.call(
      flyout.querySelectorAll(".rebuy-cart__flyout-item"),
    );
    var priceRow = findBundlePriceRowForBid(flyout, allRows, bidNorm);
    var parentItem = findBundleParentCartItem(bidNorm, cartItems);
    /** @type {Record<string, { compareCents: number | null, saleCents: number, label: string, priceRow: HTMLElement | null }>} */
    var bundlePriceByBid = {};
    bundlePriceByBid[bidNorm] = {
      compareCents: prices.compareCents,
      saleCents: prices.saleCents,
      label: parentItem ? discountLabelFromCartItem(parentItem) : "",
      priceRow: priceRow,
    };

    updateLineItemPrices(flyout, cartItems, bundlePriceByBid);
    updateCartSubtotal(flyout, cartItems, bundlePriceByBid);
  }

  /**
   * @param {HTMLElement} container
   * @param {number} saleCents
   * @param {number | null} compareCents
   */
  function paintMoneyInContainer(container, saleCents, compareCents) {
    var saleSpan = container.querySelector(
      ".rebuy-money:not(.compare-at) span:last-child",
    );
    if (!saleSpan) {
      saleSpan = container.querySelector(
        ".rebuy-cart__flyout-subtotal-amount-primary",
      );
    }
    if (!saleSpan) {
      saleSpan = container.querySelector(
        ".rebuy-cart__flyout-subtotal-final-amount",
      );
    }
    if (saleSpan) saleSpan.textContent = formatMoneyCents(saleCents);

    var compareEls = Array.prototype.slice.call(
      container.querySelectorAll(".rebuy-cart__flyout-subtotal-compare-amount"),
    );
    compareEls.forEach(function (el) {
      el.remove();
    });

    if (compareCents != null && compareCents > saleCents) {
      var compareEl = document.createElement("span");
      compareEl.className = "rebuy-cart__flyout-subtotal-compare-amount";
      compareEl.textContent = formatMoneyCents(compareCents);

      var amountWrap = container.querySelector(
        ".rebuy-cart__flyout-subtotal-amount > span:last-child",
      );
      if (saleSpan && saleSpan.parentElement) {
        saleSpan.insertAdjacentElement("afterend", compareEl);
      } else if (amountWrap) {
        amountWrap.appendChild(compareEl);
      } else {
        container.appendChild(compareEl);
      }
    }
  }

  /**
   * @param {HTMLElement} flyout
   * @param {any[]} cartItems
   * @param {Record<string, { compareCents: number | null, saleCents: number }>} bundlePriceByBid
   */
  function updateCartSubtotal(flyout, cartItems, bundlePriceByBid) {
    var subtotalComp = flyout.querySelector(
      '[data-rebuy-component="cart-subtotal"]',
    );
    if (!subtotalComp) return;

    var totals = computeCartDisplayTotals(cartItems, bundlePriceByBid);
    subtotalComp.setAttribute(
      "data-lsg-cart-display-total",
      String(totals.saleCents),
    );
    paintMoneyInContainer(
      subtotalComp,
      totals.saleCents,
      totals.compareCents,
    );
  }

  /**
   * Read Rebuy's native "Tiered Progress Bar" (free-shipping tier) straight from
   * the DOM Rebuy already rendered. We do NOT mirror its message/progress (Rebuy
   * computes those on the pre-discount subtotal); we only use its self-consistent
   * numbers to derive the configured unlock threshold. Returns null when absent.
   * @param {HTMLElement} flyout
   * @returns {{ title: string, msg: string, pct: number } | null}
   */
  function readRebuyNativeProgress(flyout) {
    try {
      var bar = flyout.querySelector(
        '[data-rebuy-cart-anchor="goalBox"] [data-rebuy-component="progress-bar"]',
      );
      if (!bar) return null;

      var labelEl = bar.querySelector(".rebuy-cart__progress-step-label");
      var promptEl = bar.querySelector(".rebuy-cart__progress-bar-prompt");
      var fillEl = bar.querySelector(".rebuy-cart__progress-bar-meter-fill");

      var pct = 0;
      if (fillEl) {
        var w = parseFloat(fillEl.style && fillEl.style.width);
        if (!isFinite(w)) w = parseFloat(fillEl.getAttribute("aria-valuenow"));
        if (isFinite(w)) pct = Math.max(0, Math.min(100, w));
      }

      var msg = promptEl
        ? (promptEl.textContent || "").replace(/\s+/g, " ").trim()
        : "";
      var title = labelEl ? (labelEl.textContent || "").trim() : "";
      if (!msg && !title) return null;
      return { title: title, msg: msg, pct: pct };
    } catch (e) {
      return null;
    }
  }

  /**
   * Create + mount the themed free-shipping banner (after the header anchor) if
   * it isn't already present. Idempotent.
   * @param {HTMLElement} flyout
   * @returns {HTMLElement | null}
   */
  function ensureFreeShippingBanner(flyout) {
    var banner = flyout.querySelector("#" + BANNER_ID);
    if (banner) return banner;

    banner = document.createElement("div");
    banner.id = BANNER_ID;
    banner.className = "lsg-rebuy-cart-free-shipping";
    banner.innerHTML =
      '<div class="lsg-rebuy-cart-free-shipping__row">' +
      '<span class="lsg-rebuy-cart-free-shipping__title" data-lsg-fs-title></span>' +
      '<span class="lsg-rebuy-cart-free-shipping__msg" data-lsg-fs-msg></span>' +
      "</div>" +
      '<div class="lsg-rebuy-cart-free-shipping__track">' +
      '<div class="lsg-rebuy-cart-free-shipping__fill" data-lsg-fs-fill></div>' +
      "</div>";

    var header = flyout.querySelector('[data-rebuy-cart-anchor="header"]');
    if (header && header.parentElement) {
      header.parentElement.insertBefore(banner, header.nextSibling);
    } else {
      flyout.insertBefore(banner, flyout.firstChild);
    }
    return banner;
  }

  /**
   * Extract the first money amount from a localized string as integer cents.
   * Store currency is USD ("$X,XXX.YY"); commas are thousands separators.
   * @param {string} text
   * @returns {number | null}
   */
  function firstMoneyCents(text) {
    if (!text) return null;
    var m = String(text).match(/[\d][\d.,]*/);
    if (!m) return null;
    var num = parseFloat(m[0].replace(/,/g, ""));
    if (!isFinite(num)) return null;
    return Math.round(num * 100);
  }

  /**
   * Discounted cart subtotal (what the customer actually pays) in cents, read
   * from Rebuy's rendered subtotal — the "final" amount, not the compare-at.
   * @param {HTMLElement} flyout
   * @returns {number | null}
   */
  function readDiscountedSubtotalCents(flyout) {
    try {
      var finalEl = flyout.querySelector(
        ".rebuy-cart__flyout-subtotal-final-amount",
      );
      if (finalEl) {
        var c = firstMoneyCents(finalEl.textContent);
        if (c != null) return c;
      }
      // No discount applied → no separate "final" node; use the plain amount.
      var amountEl = flyout.querySelector(".rebuy-cart__flyout-subtotal-amount");
      if (amountEl) {
        var c2 = firstMoneyCents(amountEl.textContent);
        if (c2 != null) return c2;
      }
    } catch (e) {
      /* ignore */
    }
    return null;
  }

  /** @type {number} cached unlock threshold (cents) derived from the config */
  var freeShipThresholdCentsCache = 0;

  /**
   * Free-shipping unlock threshold (cents). Derived from Rebuy's native progress
   * bar using only its own self-consistent numbers — with progress fraction
   * `f = base / threshold` and `remaining = threshold - base`, the base cancels:
   * `threshold = remaining / (1 - f)`. This keeps us in sync with the SmartCart
   * "Tiered Progress Bar" unlock price without depending on which subtotal Rebuy
   * uses. Cached once resolved; falls back to the static config value.
   * @param {HTMLElement} flyout
   * @returns {number}
   */
  function resolveFreeShipThresholdCents(flyout) {
    if (freeShipThresholdCentsCache > 0) return freeShipThresholdCentsCache;
    try {
      var native = readRebuyNativeProgress(flyout);
      if (native && native.pct > 0 && native.pct < 100) {
        var remainCents = firstMoneyCents(native.msg);
        if (remainCents != null && remainCents > 0) {
          var threshold = Math.round(remainCents / (1 - native.pct / 100));
          if (threshold > 0) {
            freeShipThresholdCentsCache = threshold;
            return threshold;
          }
        }
      }
    } catch (e) {
      /* fall through to static fallback */
    }
    return freeShippingThresholdCents();
  }

  /**
   * @param {HTMLElement} flyout
   * @param {any} [cart]
   * @param {number | null} [displaySubtotalCents]
   */
  function updateFreeShippingBanner(flyout, cart, displaySubtotalCents) {
    if (!flyout) return;

    var threshold = resolveFreeShipThresholdCents(flyout);
    if (!threshold || threshold <= 0) {
      flyout.querySelectorAll("#" + BANNER_ID).forEach(function (el) {
        el.remove();
      });
      return;
    }

    // Always measure against the DISCOUNTED subtotal (what the customer pays),
    // not the pre-discount/compare price Rebuy's native bar uses.
    var subtotal = displaySubtotalCents;
    if (subtotal == null) subtotal = readDiscountedSubtotalCents(flyout);
    if (subtotal == null && cart) {
      subtotal =
        cart.items_subtotal_price != null
          ? cart.items_subtotal_price
          : cart.total_price;
    }
    // Subtotal unknown (e.g. observer refresh before amounts render): keep the
    // existing banner untouched rather than showing a wrong value.
    if (subtotal == null) return;
    subtotal = Number(subtotal) || 0;

    var remaining = Math.max(0, threshold - subtotal);
    var pct = Math.min(100, Math.round((subtotal / threshold) * 100));
    var unlocked = remaining <= 0;

    var str = lsgStrings();
    var title = str.heading;
    var msg = unlocked
      ? str.unlocked
      : applyRemainderTemplate(str.remainingTpl, formatMoneyCents(remaining));

    var banner = ensureFreeShippingBanner(flyout);
    if (!banner) return;

    var role = unlocked ? "status" : "progressbar";
    if (banner.getAttribute("role") !== role) banner.setAttribute("role", role);
    if (unlocked) banner.setAttribute("aria-live", "polite");
    else banner.removeAttribute("aria-live");

    var titleEl = banner.querySelector("[data-lsg-fs-title]");
    var msgEl = banner.querySelector("[data-lsg-fs-msg]");
    var fillEl = banner.querySelector("[data-lsg-fs-fill]");

    // Idempotent writes so our updates don't retrigger the re-inject observer.
    if (titleEl && titleEl.textContent !== title) titleEl.textContent = title;
    if (msgEl && msgEl.textContent !== msg) msgEl.textContent = msg;
    var widthStr = String(pct) + "%";
    if (fillEl && fillEl.style.width !== widthStr) fillEl.style.width = widthStr;

    var nowStr = String(Math.round(pct));
    if (banner.getAttribute("aria-valuemin") !== "0")
      banner.setAttribute("aria-valuemin", "0");
    if (banner.getAttribute("aria-valuemax") !== "100")
      banner.setAttribute("aria-valuemax", "100");
    if (banner.getAttribute("aria-valuenow") !== nowStr)
      banner.setAttribute("aria-valuenow", nowStr);
  }

  /**
   * @param {HTMLElement} li
   * @param {any[]} cartItems
   */
  function injectParentDiscountChip(li, cartItems, bidNorm) {
    var parentItem = findBundleParentCartItem(bidNorm, cartItems);

    /** remove old */
    var info = li.querySelector(".rebuy-cart__flyout-item-info");
    if (!info) return;

    info.querySelectorAll("." + PARENT_CHIP_MARKER).forEach(function (el) {
      el.remove();
    });

    if (!parentItem) return;

    var label = discountLabelFromCartItem(parentItem);
    /** Show chip if Shopify reports line-level allocations */
    if (!label) {
      /** Still show compare-original vs final on parent elsewhere (Rebuy does); skip chip */
      return;
    }

    var anchor =
      info.querySelector(".rebuy-cart__flyout-item-variant-title") ||
      info.querySelector(".rebuy-cart__flyout-item-product-title");
    if (!anchor) return;

    var chip = document.createElement("span");
    chip.className =
      "rebuy-cart__stay-bundle-chip rebuy-cart__stay-bundle-parent-chip";
    chip.textContent = label;
    anchor.insertAdjacentElement("afterend", chip);
  }

  /**
   * @param {HTMLElement} li
   * @param {any[]} cartItems
   */
  function injectForRow(li, cartItems) {
    li.querySelectorAll("." + INJECTED_CLASS).forEach(function (el) {
      el.remove();
    });

    var bidNorm = normBid(getFlyoutProp(li, "bundle_id"));
    if (!bidNorm) return;

    injectParentDiscountChip(li, cartItems, bidNorm);

    var lines = [];
    for (var i = 0; i < cartItems.length; i++) {
      var item = cartItems[i];
      var p = item.properties;
      if (!p || typeof p !== "object") continue;
      if (normBid(p.bundle_id) !== bidNorm) continue;
      var isParent = p.bundle_parent === true || p.bundle_parent === "true";
      if (isParent) continue;
      lines.push(item);
    }

    if (!lines.length) return;

    var root = document.createElement("div");
    root.className = INJECTED_CLASS;

    lines.forEach(function (item) {
      var vt =
        item.variant_title && item.variant_title !== "Default Title"
          ? item.variant_title
          : "";
      var pt =
        item.product_title && item.product_title !== vt
          ? item.product_title
          : "";
      /** If only one title fallback */
      var titleLine = vt || pt || item.title || "Item";
      var subtitleLine = vt && pt && vt !== pt ? pt : "";

      var qty = Number(item.quantity) || 0;
      var orig =
        typeof item.original_line_price === "number"
          ? item.original_line_price
          : typeof item.final_line_price === "number"
            ? item.final_line_price
            : null;
      var fin =
        typeof item.final_line_price === "number"
          ? item.final_line_price
          : typeof item.line_price === "number"
            ? item.line_price
            : orig;

      var row = document.createElement("div");
      row.className = "rebuy-cart__stay-bundle-row";

      var titles = document.createElement("div");
      titles.className = "rebuy-cart__stay-bundle-row__titles";

      var variantEl = document.createElement("span");
      variantEl.className = "rebuy-cart__stay-bundle-row__variant";
      variantEl.textContent = titleLine;
      titles.appendChild(variantEl);

      if (subtitleLine) {
        var productEl = document.createElement("span");
        productEl.className = "rebuy-cart__stay-bundle-row__product";
        productEl.textContent = subtitleLine;
        titles.appendChild(productEl);
      }

      row.appendChild(titles);

      var bd = discountLabelFromCartItem(item);
      if (bd) {
        var badge = document.createElement("span");
        badge.className = "rebuy-cart__stay-bundle-row__badge";
        badge.textContent = bd;
        row.appendChild(badge);
      }

      var bottom = document.createElement("div");
      bottom.className = "rebuy-cart__stay-bundle-row__bottom";

      var qtyWrap = document.createElement("span");
      qtyWrap.className = "rebuy-cart__stay-bundle-row__qty";
      qtyWrap.textContent =
        qty > 1 ? "\u00d7 " + qty : qty === 1 ? "\u00d7 1" : "";
      bottom.appendChild(qtyWrap);

      var prices = document.createElement("div");
      prices.className = "rebuy-cart__stay-bundle-row__prices";

      if (typeof fin === "number" && fin > 0) {
        if (typeof orig === "number" && orig !== fin && orig > fin) {
          var cmp = document.createElement("span");
          cmp.className =
            "rebuy-cart__stay-bundle-row__price rebuy-cart__stay-bundle-row__price--compare";
          cmp.textContent = formatMoneyCents(orig);
          prices.appendChild(cmp);
        }
        var pr = document.createElement("span");
        pr.className = "rebuy-cart__stay-bundle-row__price";
        pr.textContent = formatMoneyCents(fin);
        prices.appendChild(pr);
      }
      if (prices.childNodes.length) bottom.appendChild(prices);

      row.appendChild(bottom);

      root.appendChild(row);
    });

    /** Insert after anchor (prioritize inserted parent chip location) */
    var infoInner = li.querySelector(".rebuy-cart__flyout-item-info");
    if (!infoInner) return;

    var anchor =
      infoInner.querySelector("." + PARENT_CHIP_MARKER) ||
      infoInner.querySelector(".rebuy-cart__flyout-item-variant-title") ||
      infoInner.querySelector(".rebuy-cart__flyout-item-product-title");
    if (anchor) {
      anchor.insertAdjacentElement("afterend", root);
    } else {
      infoInner.appendChild(root);
    }
  }

  /**
   * @param {HTMLElement} flyout
   * @param {any} cart
   * @param {Record<string, { selectValue: string, subPercent: number }> | null} [pricingIntentByBid]
   */
  function applyBundleCartPricing(flyout, cart, pricingIntentByBid) {
    if (!flyout || !cart) return;
    normalizeCheckoutLabels(flyout);
    dedupeSubscriptionSelectsSoon();
    var cartItems = cart.items || [];
    var bundlePriceByBid = buildBundlePriceMap(
      flyout,
      cartItems,
      pricingIntentByBid,
    );
    dedupeSubscriptionSelectsSoon();
    var displayTotals = computeCartDisplayTotals(cartItems, bundlePriceByBid);
    updateFreeShippingBanner(flyout, cart, displayTotals.saleCents);
    updateBundleLineQuantities(flyout, cartItems);
    updateLineItemPrices(flyout, cartItems, bundlePriceByBid);
    updateCartSubtotal(flyout, cartItems, bundlePriceByBid);
  }

  /**
   * Paint final bundle prices while hidden, let Rebuy settle, repaint, then reveal once.
   * @param {HTMLElement} flyout
   * @param {any} cart
   * @param {string} bidNorm
   * @param {{ selectValue: string, subPercent: number }} pricingIntent
   * @returns {Promise<void>}
   */
  function finishBundleSubscriptionUpdate(flyout, cart, bidNorm, pricingIntent) {
    if (!flyout || !cart) return Promise.resolve();

    /** @type {Record<string, { selectValue: string, subPercent: number }> | null} */
    var pricingIntentByBid = null;
    if (bidNorm && pricingIntent) {
      pricingIntentByBid = {};
      pricingIntentByBid[bidNorm] = pricingIntent;
    }

    bundleSubSuppressScheduleUntil = Date.now() + 1200;

    function done(/** @type {any} */ c) {
      bundleSubLastCartForGuard = c;
      applyBundleCartPricing(flyout, c, pricingIntentByBid);
      if (
        bidNorm &&
        pricingIntent &&
        cartMatchesPendingSubscription(
          bidNorm,
          c.items || [],
          pricingIntent,
        )
      ) {
        clearPendingBundleSubscription(bidNorm);
      }
      bundleSubAwaitingHydrateReveal = true;
      bundleSubHydrateSkipRepair = true;
      bundleSubHydratePricingIntentByBid = pricingIntentByBid;
      return hydrate().finally(function () {
        bundleSubHydratePricingIntentByBid = null;
        if (!bundleSubAwaitingHydrateReveal) return;
        bundleSubAwaitingHydrateReveal = false;
        applyBundleCartPricing(flyout, c, pricingIntentByBid);
        scheduleBundleSubStableRelease(flyout, c, bidNorm, pricingIntent);
      });
    }

    return fetchCartJson()
      .then(function (freshCart) {
        return done(freshCart || cart);
      })
      .catch(function () {
        return done(cart);
      });
  }

  async function hydrate() {
    debounceTimer = null;
    /** @type {HTMLElement | null} */
    var flyout = document.querySelector(".rebuy-cart__flyout");
    var cartItemsRoot = document.querySelector(CART_ITEMS_SEL);

    var cart = null;
    var skipBundleRepair = bundleSubHydrateSkipRepair;
    bundleSubHydrateSkipRepair = false;

    /** Always fetch cart for banner even if no bundle rows yet */
    try {
      var res = await fetch(cartJsUrl(), {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      cart = await res.json();
      cacheLastCartItems(cart);
    } catch (e) {
      if (bundleSubAwaitingHydrateReveal) {
        bundleSubAwaitingHydrateReveal = false;
        bundleSubHydratePricingIntentByBid = null;
        releaseBundleSubMutationUi();
        bundleSubCartUpdating = false;
      }
      return;
    }

    if (!cart) {
      if (bundleSubAwaitingHydrateReveal) {
        bundleSubAwaitingHydrateReveal = false;
        bundleSubHydratePricingIntentByBid = null;
        releaseBundleSubMutationUi();
        bundleSubCartUpdating = false;
      }
      return;
    }

    ensureSubscriptionSelectObserver();

    if (flyout) {
      normalizeCheckoutLabels(flyout);
      dedupeSubscriptionSelectsSoon();
      var cartItems = cart.items || [];
      var repaired = skipBundleRepair
        ? false
        : await repairAllMixedBundleSubscriptions(flyout, cartItems);
      if (repaired) {
        try {
          var res2 = await fetch(cartJsUrl(), {
            headers: { Accept: "application/json" },
            credentials: "same-origin",
          });
          cart = await res2.json();
          cacheLastCartItems(cart);
          cartItems = cart.items || [];
        } catch (_repairErr) {
          /* keep prior cart */
        }
      }
      var bundlePriceByBid = buildBundlePriceMap(
        flyout,
        cartItems,
        bundleSubHydratePricingIntentByBid,
      );
      dedupeSubscriptionSelectsSoon();
      var displayTotals = computeCartDisplayTotals(
        cartItems,
        bundlePriceByBid,
      );
      updateFreeShippingBanner(flyout, cart, displayTotals.saleCents);
      updateBundleLineQuantities(flyout, cartItems);
      updateLineItemPrices(flyout, cartItems, bundlePriceByBid);
      updateCartSubtotal(flyout, cartItems, bundlePriceByBid);
      void updateLineItemMedia(flyout, cartItems);
    }

    if (!cartItemsRoot) {
      if (bundleSubAwaitingHydrateReveal) {
        bundleSubAwaitingHydrateReveal = false;
        bundleSubHydratePricingIntentByBid = null;
        releaseBundleSubMutationUi();
        bundleSubCartUpdating = false;
      }
      return;
    }

    var rows = cartItemsRoot.querySelectorAll(".rebuy-cart__flyout-item");

    var cartItems = cart.items || [];

    rows.forEach(function (r) {
      if (flyout && flyout.contains && !flyout.contains(r)) return;
      injectBundleBoxesLabel(/** @type {HTMLElement} */ (r), cartItems);
      if (isBundleParentRow(r))
        injectForRow(/** @type {HTMLElement} */ (r), cartItems);
    });
  }

  /** @returns {string} */
  function productThumbnailSectionUrl(handle) {
    var root =
      typeof Shopify !== "undefined" && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : "/";
    if (root.slice(-1) !== "/") root += "/";
    return (
      root +
      "products/" +
      encodeURIComponent(handle) +
      "?sections=288-product-thumbnail"
    );
  }

  /**
   * @param {string} handle
   * @returns {Promise<{ default: string, byVariantId: Record<string, string> } | null>}
   */
  function fetchProductThumbnails(handle) {
    if (!handle) return Promise.resolve(null);
    if (productThumbnailCache[handle]) return productThumbnailCache[handle];

    productThumbnailCache[handle] = fetch(productThumbnailSectionUrl(handle), {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        if (!data) return null;
        var html = data["288-product-thumbnail"];
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var el = doc.querySelector("[data-288-product-thumbnails]");
        if (!el || !el.textContent) return null;
        return JSON.parse(el.textContent);
      })
      .catch(function () {
        return null;
      });

    return productThumbnailCache[handle];
  }

  /**
   * @param {HTMLElement} row
   * @param {any[]} cartItems
   * @param {Record<number, boolean>} usedCartItemIndexes
   * @returns {any | null}
   */
  function findCartItemForRow(row, cartItems, usedCartItemIndexes) {
    var titleLink = row.querySelector(".rebuy-cart__flyout-item-product-title");
    var href = titleLink ? titleLink.getAttribute("href") || "" : "";
    var handleMatch = href.match(/\/products\/([^?#/]+)/);
    var handle = handleMatch ? handleMatch[1] : "";

    var variantTitleEl = row.querySelector(
      ".rebuy-cart__flyout-item-variant-title",
    );
    var variantTitle = normalizeVariantTitle(
      variantTitleEl ? variantTitleEl.textContent : "",
    );

    for (var i = 0; i < cartItems.length; i++) {
      if (usedCartItemIndexes[i]) continue;

      var ci = cartItems[i];
      if (
        ci.handle === handle &&
        normalizeVariantTitle(ci.variant_title) === variantTitle
      ) {
        usedCartItemIndexes[i] = true;
        return ci;
      }
    }

    return null;
  }

  /**
   * Sync line media with theme thumbnail metafields (variety packs, flavor thumbs).
   * @param {HTMLElement} flyout
   * @param {any[]} cartItems
   */
  async function updateLineItemMedia(flyout, cartItems) {
    var usedCartItemIndexes = {};
    var tasks = [];

    flyout.querySelectorAll(".rebuy-cart__flyout-item").forEach(function (row) {
      var mediaEl = row.querySelector(".rebuy-cart__flyout-item-media img");
      if (!mediaEl) return;

      var cartItem = findCartItemForRow(row, cartItems, usedCartItemIndexes);
      if (!cartItem || !cartItem.handle) return;

      tasks.push(
        fetchProductThumbnails(cartItem.handle).then(function (thumbs) {
          if (!thumbs) return;

          var variantKey = String(cartItem.variant_id);
          var url =
            (thumbs.byVariantId && thumbs.byVariantId[variantKey]) ||
            thumbs.default;
          if (!url || mediaEl.getAttribute("src") === url) return;

          mediaEl.setAttribute("src", url);
          mediaEl.removeAttribute("srcset");
          mediaEl.removeAttribute("sizes");
        }),
      );
    });

    await Promise.all(tasks);
  }

  /**
   * @param {HTMLElement} priceEl
   * @param {number} saleCents
   * @param {number | null} compareCents
   * @param {string} discountLabel
   */
  function paintFlyoutLinePrice(priceEl, saleCents, compareCents, discountLabel) {
    priceEl.setAttribute("data-lsg-line-price", String(saleCents));

    var salePriceSpan = priceEl.querySelector(
      ".rebuy-money:not(.compare-at) span:last-child",
    );
    if (salePriceSpan) salePriceSpan.textContent = formatMoneyCents(saleCents);

    var compareMoneyEl = priceEl.querySelector(".rebuy-money.compare-at");
    if (compareCents != null && compareCents > saleCents) {
      if (!compareMoneyEl) {
        compareMoneyEl = document.createElement("span");
        compareMoneyEl.className = "rebuy-money compare-at";
        compareMoneyEl.innerHTML =
          '<span class="sr-only">Original price</span> <span></span>';
        var priceWrapper = priceEl.querySelector("div");
        if (priceWrapper) priceWrapper.appendChild(compareMoneyEl);
        else priceEl.appendChild(compareMoneyEl);
      }
      var compareSpan = compareMoneyEl.querySelector("span:last-child");
      if (compareSpan) compareSpan.textContent = formatMoneyCents(compareCents);
    } else if (compareMoneyEl) {
      compareMoneyEl.remove();
    }

    var existingChip = priceEl.querySelector(".lsg-rebuy-line-discount-chip");
    if (discountLabel) {
      if (!existingChip) {
        existingChip = document.createElement("span");
        existingChip.className =
          "lsg-rebuy-line-discount-chip rebuy-cart__stay-bundle-chip";
        priceEl.appendChild(existingChip);
      }
      existingChip.textContent = discountLabel;
    } else if (existingChip) {
      existingChip.remove();
    }
  }

  /**
   * Replace Rebuy's unit prices with line totals from cart.js.
   * @param {HTMLElement} flyout
   * @param {any[]} cartItems
   * @param {Record<string, { compareCents: number | null, saleCents: number, label: string, priceRow: HTMLElement }>} bundlePriceByBid
   */
  /**
   * Split a bundle total into integer cents per line, proportional to each
   * line's quantity. The remainder is absorbed via running prefix rounding so
   * the parts always sum back to the original total (the cart subtotal is
   * therefore unchanged).
   * @param {number} total
   * @param {number[]} qtys
   * @returns {number[]}
   */
  function allocateProportionalCents(total, qtys) {
    var totalQty = 0;
    for (var i = 0; i < qtys.length; i++) totalQty += qtys[i];
    var out = [];
    if (totalQty <= 0) {
      for (var z = 0; z < qtys.length; z++) out.push(0);
      return out;
    }
    var cum = 0;
    var prev = 0;
    for (var j = 0; j < qtys.length; j++) {
      cum += qtys[j];
      var target = Math.round((total * cum) / totalQty);
      out.push(target - prev);
      prev = target;
    }
    return out;
  }

  function updateLineItemPrices(flyout, cartItems, bundlePriceByBid) {
    var usedCartItemIndexes = {};
    var allRows = Array.prototype.slice.call(
      flyout.querySelectorAll(".rebuy-cart__flyout-item"),
    );

    // Match every row to its cart line (for quantity) and group bundle rows by
    // bundle id, preserving DOM order so the proportional split lines up.
    /** @type {Record<string, { entries: any[], qtys: number[] }>} */
    var bundleGroups = {};
    /** @type {any[]} */
    var rowInfos = [];

    allRows.forEach(function (row) {
      var priceEl = row.querySelector(".rebuy-cart__flyout-item-price");
      if (!priceEl) return;

      var bidNorm = normBid(getFlyoutProp(row, "bundle_id"));
      var bundlePrice = bidNorm ? bundlePriceByBid[bidNorm] : null;
      var cartItem = findCartItemForFlyoutRow(
        row,
        cartItems,
        usedCartItemIndexes,
      );
      var qty = cartItem
        ? Number(cartItem.quantity) || 1
        : parseQtyFromQuantityWidget(row) || 1;

      var info = {
        row: row,
        priceEl: priceEl,
        bundlePrice: bundlePrice,
        cartItem: cartItem,
        qty: qty,
        handled: false,
      };
      rowInfos.push(info);

      if (bundlePrice) {
        if (!bundleGroups[bidNorm]) {
          bundleGroups[bidNorm] = { entries: [], qtys: [] };
        }
        bundleGroups[bidNorm].entries.push(info);
        bundleGroups[bidNorm].qtys.push(qty);
      }
    });

    // Each bundle line shows its own share: (bundle total / total boxes) × line
    // quantity, for both sale and regular price. Parts sum to the bundle total.
    Object.keys(bundleGroups).forEach(function (bid) {
      var group = bundleGroups[bid];
      var bp = group.entries[0].bundlePrice;
      var saleParts = allocateProportionalCents(bp.saleCents, group.qtys);
      var compareParts =
        bp.compareCents != null
          ? allocateProportionalCents(bp.compareCents, group.qtys)
          : null;

      for (var i = 0; i < group.entries.length; i++) {
        var entry = group.entries[i];
        entry.handled = true;
        entry.row.classList.remove("lsg-rebuy-bundle-price-secondary");
        entry.priceEl.style.display = "";
        paintFlyoutLinePrice(
          entry.priceEl,
          saleParts[i],
          compareParts ? compareParts[i] : null,
          i === 0 ? bp.label : "",
        );
      }
    });

    // Non-bundle rows keep their per-line cart pricing.
    rowInfos.forEach(function (info) {
      if (info.bundlePrice || info.handled) return;
      info.row.classList.remove("lsg-rebuy-bundle-price-secondary");
      info.priceEl.style.display = "";
      if (!info.cartItem) return;

      var originalLineCents = originalLinePriceCents(info.cartItem, info.row);
      paintFlyoutLinePrice(
        info.priceEl,
        Number(info.cartItem.final_line_price) || 0,
        originalLineCents,
        discountLabelFromCartItem(info.cartItem),
      );
    });
  }

  function schedule(ev) {
    if (bundleSubCartUpdating) {
      bundleSubHydrateQueued = true;
      return;
    }
    if (Date.now() < bundleSubSuppressScheduleUntil) return;
    if (
      ev &&
      ev.detail &&
      ev.detail.sourceId === "rebuy-bundle-sub"
    ) {
      return;
    }
    dedupeSubscriptionSelectsSoon();
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      void hydrate();
    }, 180);
  }

  window.addEventListener("load", schedule, { passive: true });
  document.documentElement.addEventListener("cart:updated", schedule);
  document.documentElement.addEventListener("shopify:cart:change", schedule);
  document.addEventListener("cart:update", schedule);
  document.addEventListener(
    "change",
    function (e) {
      if (!(e.target instanceof HTMLSelectElement)) return;
      var select = e.target;
      if (!select.closest(".rebuy-cart__flyout-item-subscription")) return;

      dedupeSubscriptionSelect(select);

      var row = select.closest(".rebuy-cart__flyout-item");
      var bidNorm = row ? normBid(getFlyoutProp(row, "bundle_id")) : "";

      if (!bidNorm) {
        dedupeSubscriptionSelectsSoon();
        schedule();
        return;
      }

      e.stopImmediatePropagation();

      var flyout = document.querySelector(".rebuy-cart__flyout");
      if (!flyout) return;

      bundleSubCartUpdating = true;
      bundleSubSuppressScheduleUntil = Date.now() + 8000;

      setPendingBundleSubscription(
        bidNorm,
        select.value,
        subscriptionDiscountPercentFromSelect(select),
      );
      /** @type {Record<string, { selectValue: string, subPercent: number }>} */
      var changePricingIntentByBid = {};
      changePricingIntentByBid[bidNorm] = getPendingBundleSubscription(bidNorm);
      beginBundleSubMutationUi(flyout, bidNorm, changePricingIntentByBid);
      if (lastCartItems.length) {
        repaintBundlePricesForSelect(flyout, lastCartItems, bidNorm, select);
      }

      void ensureBundleSubscriptionSelectsOnAllRows(flyout, bidNorm).then(function () {
        reapplyBundleSubRowMarkers();
        syncBundleSubscriptionSelectsFromRow(flyout, bidNorm, select);
        return updateBundleSubscriptionInCart(bidNorm, select.value, row);
      });
    },
    true,
  );

  document.addEventListener(
    "click",
    function (e) {
      if (!(e.target instanceof Element)) return;
      var btn = e.target.closest(
        ".rebuy-cart__flyout-item-subscription button.rebuy-button",
      );
      if (!btn) return;

      var row = btn.closest(".rebuy-cart__flyout-item");
      if (!row || !isBundleFlavorRow(row)) return;

      var bidNorm = normBid(getFlyoutProp(row, "bundle_id"));
      if (!bidNorm) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var flyout = document.querySelector(".rebuy-cart__flyout");
      if (!flyout) return;

      if (bundleAllRowsShowUpgradeButton(flyout, bidNorm)) {
        void revealBundleSubscriptionSelectsForBid(flyout, bidNorm);
        return;
      }

      var planValue = getDefaultBundleSubscriptionSelectValue(flyout, bidNorm);
      if (!planValue) return;

      bundleSubCartUpdating = true;
      bundleSubSuppressScheduleUntil = Date.now() + 8000;

      void ensureBundleSubscriptionSelectsOnAllRows(flyout, bidNorm).then(function () {
        syncBundleSubscriptionSelectsFromValue(flyout, bidNorm, planValue);
        var sel = row.querySelector(
          ".rebuy-cart__flyout-item-subscription select",
        );
        setPendingBundleSubscription(
          bidNorm,
          planValue,
          sel
            ? subscriptionDiscountPercentFromSelect(
                /** @type {HTMLSelectElement} */ (sel),
              )
            : 10,
        );
        /** @type {Record<string, { selectValue: string, subPercent: number }>} */
        var clickPricingIntentByBid = {};
        clickPricingIntentByBid[bidNorm] = getPendingBundleSubscription(bidNorm);
        beginBundleSubMutationUi(flyout, bidNorm, clickPricingIntentByBid);
        if (lastCartItems.length && sel) {
          repaintBundlePricesForSelect(
            flyout,
            lastCartItems,
            bidNorm,
            /** @type {HTMLSelectElement} */ (sel),
          );
        }

        return updateBundleSubscriptionInCart(bidNorm, planValue, row);
      });
    },
    true,
  );

  /** Move a fully-initialized cross-sell node into the footer before subtotal. */
  /** Inject a category pill above the title for each product card in the cross-sell widget. */
  function injectCrossSellPills(cs) {
    cs.querySelectorAll(".rebuy-product-info").forEach(function (info) {
      if (info.querySelector(".lsg-rebuy-product-pill")) return;
      var titleEl = info.querySelector(".rebuy-product-title");
      var fullTitle = titleEl ? (titleEl.textContent || "").trim() : "";
      /* Extract the part before " - " (e.g. "Chia Overnight Mix - Variety Pack (24)" → "Chia Overnight Mix") */
      var label = fullTitle.split(" - ")[0].trim();
      if (!label) return;
      var pill = document.createElement("span");
      pill.className = "lsg-rebuy-product-pill";
      pill.textContent = label;
      info.insertBefore(pill, info.firstChild);
    });
  }

  function injectCrossSellDots(cs) {
    var splideEl = cs.querySelector(".splide");
    if (!splideEl) return;

    /* Remove stale dots from a previous render */
    splideEl.querySelectorAll(".lsg-rebuy-dots").forEach(function (el) {
      el.remove();
    });

    var slides = Array.prototype.slice.call(
      splideEl.querySelectorAll(".splide__slide:not(.splide__slide--clone)"),
    );
    if (slides.length <= 1) return;

    var dots = document.createElement("div");
    dots.className = "lsg-rebuy-dots";

    slides.forEach(function (slide, i) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className =
        "lsg-rebuy-dot" + (i === 0 ? " lsg-rebuy-dot--active" : "");
      btn.setAttribute("aria-label", "Go to slide " + (i + 1));
      dots.appendChild(btn);
    });

    splideEl.appendChild(dots);

    function syncDots(activeSlide) {
      dots.querySelectorAll(".lsg-rebuy-dot").forEach(function (btn, i) {
        btn.classList.toggle(
          "lsg-rebuy-dot--active",
          slides[i] === activeSlide,
        );
      });
    }

    /* Use Splide event API if the instance is available */
    var instance = splideEl._splide || splideEl.splide;
    if (instance && typeof instance.on === "function") {
      instance.on("move", function (newIndex) {
        syncDots(slides[newIndex]);
      });
    } else {
      /* Fallback: watch for Splide's is-active class changes */
      new MutationObserver(function () {
        var active = splideEl.querySelector(
          ".splide__slide.is-active:not(.splide__slide--clone)",
        );
        if (active) syncDots(active);
      }).observe(splideEl, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  function placeCrossSellInFooter(cs, footer) {
    if (!cs || !footer || footer.contains(cs)) return;
    if (!cs.classList.contains(CROSS_SELL_FOOTER_CLASS))
      cs.classList.add(CROSS_SELL_FOOTER_CLASS);
    var subtotal = footer.querySelector(
      '[data-rebuy-component="cart-subtotal"]',
    );
    if (subtotal) footer.insertBefore(cs, subtotal);
    else footer.appendChild(cs);
    injectCrossSellPills(cs);
    injectCrossSellDots(cs);
  }

  /** Returns the nearest cross-sell ancestor/self if it is initialized (data-initialized="true"). */
  function initializedCrossSell(el) {
    var cs = el.closest
      ? el.closest('[data-rebuy-component="cross-sell-widget"]')
      : null;
    if (!cs) {
      /* el itself might be the cross-sell wrapper */
      cs =
        el.getAttribute &&
        el.getAttribute("data-rebuy-component") === "cross-sell-widget"
          ? el
          : null;
      if (!cs && el.querySelector)
        cs = el.querySelector('[data-rebuy-component="cross-sell-widget"]');
    }
    if (!cs) return null;
    if (cs.querySelector('[data-initialized="true"]')) return cs;
    return null;
  }

  new MutationObserver(function (mutations) {
    /* Fast synchronous path: move cross-sell once it is fully initialized */
    var flyout = document.querySelector(".rebuy-cart__flyout");
    var footer =
      flyout && flyout.querySelector('[data-rebuy-cart-anchor="footer"]');
    if (footer) {
      for (var i = 0; i < mutations.length; i++) {
        var mut = mutations[i];
        /* Skip mutations inside the footer (our own moves) */
        if (footer.contains(mut.target)) continue;

        var cs = null;
        if (
          mut.type === "attributes" &&
          mut.attributeName === "data-initialized"
        ) {
          /* Vue just set data-initialized on an inner node — check its cross-sell parent */
          cs = initializedCrossSell(mut.target);
        } else if (mut.type === "childList") {
          for (var j = 0; j < mut.addedNodes.length; j++) {
            var n = mut.addedNodes[j];
            if (n.nodeType !== 1) continue;
            cs = initializedCrossSell(n);
            if (cs) break;
          }
        }

        if (cs) {
          placeCrossSellInFooter(cs, footer);
          break;
        }
      }
    }
    /* Slow debounced path: banner + bundle rows */
    ensureSubscriptionSelectObserver();
    schedule();
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["data-initialized"],
  });

  ensureSubscriptionSelectObserver();
  schedule();
})();
